/* ============ Lightweight i18n: da (primary) / en / de / it / fr / es ============
   t("key") or t("key", {var: value}) for {var} templates.
   Language is stored in localStorage; App remounts the tree on switch.
   Missing keys fall back to Danish, so a new language can ship gradually. */

const KEY = "carnival.lang";

export const LANGS = ["da", "en", "de", "it", "fr", "es"];

/* Sprogvalg: 1) brugerens gemte valg, 2) auto-detektion fra browserens
   sprogliste (navigator.languages, første sprog vi har), 3) engelsk.
   Auto-detektionen gemmes IKKE, først et aktivt valg i flag-menuen låser
   sproget, så nye sprog senere kan samle deres brugere op automatisk. */
let lang = "en";
try {
  const stored = localStorage.getItem(KEY);
  if (LANGS.includes(stored)) {
    lang = stored;
  } else {
    const prefs = (navigator.languages && navigator.languages.length
      ? navigator.languages
      : [navigator.language || ""]).map((s) => String(s).slice(0, 2).toLowerCase());
    lang = prefs.find((p) => LANGS.includes(p)) || "en";
  }
} catch {}

export function getLang() { return lang; }
export function setLang(l) {
  lang = LANGS.includes(l) ? l : "da";
  try { localStorage.setItem(KEY, lang); } catch {}
}

export function t(key, vars) {
  let s = (DICT[lang] && DICT[lang][key]) ?? DICT.da[key] ?? key;
  if (vars) for (const k of Object.keys(vars)) s = s.replaceAll("{" + k + "}", vars[k]);
  return s;
}

/* CPU-navnepuljer bor i sprog-ordbogen (nøgle: names_<kind>), så kommende
   sprog (de/it/fr/es) bare medbringer deres egne, fallback til dansk som t().
   sampleNames trækker n TILFÆLDIGE navne, så man ikke møder de samme hver gang. */
export function sampleNames(kind, n) {
  const pool = [...(((DICT[lang] || {})["names_" + kind]) || DICT.da["names_" + kind] || [])];
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  return pool.slice(0, n);
}

const DICT = {
  da: {
    // menu
    menu_welcome: "VELKOMMEN TIL BODEN",
    menu_allwin: "ALLE KAN VINDE",
    play: "SPIL",
    tile_horse: "Hestevæddeløb",
    tile_football: "Fodbold",
    tile_basket: "Basketball",
    tile_shoot: "Skydeteltet",
    tile_prizes: "Præmierum",
    tile_board: "Leaderboard",
    prizes_one: "PRÆMIE",
    prizes_many: "PRÆMIER",
    board_go: "SE LISTEN",
    footer_privacy: "Privatliv",
    // name
    name_q: "Hvad hedder du?",
    name_note: "Navnet vises på leaderboardet og på væddeløbsbanen. Brug gerne et kaldenavn, det kan ses af alle spillere.",
    name_ph: "Dit navn",
    name_save: "GEM",
    name_err_len: "Navnet skal være 2-12 tegn.",
    name_err_rude: "Det navn kan vi ikke skrive på pokalen… prøv et andet.",
    // common
    back: "‹ Menu",
    sign_free: "GRATIS",
    play_again: "Spil igen",
    try_again: "Prøv igen",
    to_menu: "Til menuen",
    your_prize: "Din præmie:",
    in_room: "– den står nu i præmierummet!",
    you: "Dig",
    // sizes / colors / types
    ld_h1: "Teddy Chase – klassiske boder og sjove spil online",
    ld_intro: "Teddy Chase er en gratis samling af femten klassiske boder fra forlystelsesparken, som du kan spille direkte i browseren, på mobil, tablet og computer, uden download og uden køb. Vind tøjdyr i glade farver og blanke guldpokaler, fyld dit præmierum og kæmp om pladserne på det globale leaderboard. Spillet findes på seks sprog: dansk, engelsk, tysk, italiensk, fransk og spansk.",
    ld_g_horse: "Bodernes konge: rul kugler op ad rampen og ram hullerne, hvert point rykker din hest mod mål. Tre baner, blokker-pinde og op til fem modstandere.",
    ld_g_claw: "Klassisk klomaskine online: tryk i rette øjeblik, og fisk præcis det tøjdyr, du kan se i bunken. Tre forsøg pr. kvarter, så gør dem gode.",
    ld_g_shoot: "Skydetelt som i den ægte forlystelsespark: tre rækker monstre i fart, ram 7 for præmie, ram alle 10 og tag guldpokalen.",
    ld_g_wheel: "Gæt 3 af hjulets 20 tal og drej. Lander pilen på dit tal, er det mellemstore tøjdyr dit.",
    ld_g_race: "Radiobil-ræs set fra oven med joystick, boosts og albuer, tre baner, fem omgange, og guldpokal til den, der vinder på Svær.",
    ld_g_football: "Otte skud mod en målmand, der finter og eskalerer. Skru bolden uden om ham, otte mål i træk giver pokalen og hat-trick-jubel undervejs.",
    ld_g_basket: "Tre levels mod uret med en kurv, der glider hurtigere og hurtigere. Gennemfør finalen og vælg dit tøjdyr.",
    ld_g_mole: "60 sekunder, ni huller og muldvarpe i stadigt højere tempo, de gyldne giver tre point, og kiggerne er næsten umulige at nå.",
    ld_g_cans: "Dåsekast med rigtig fysik: vælt hele pyramiden ned fra bordet på fem kast. Klarer du det på to, venter guldpokalen.",
    ld_g_hang: "Hold linedanseren i balance i vinden, med mus, piletaster eller ved at vippe telefonen. Jo længere tid, jo større præmie.",
    ld_g_punch: "Fire trin, ét tryk pr. trin: gå perfekt tilbage, tag antræk, find kræfterne frem og flyv ind i boksesækken. Op til 1.000 point, og du kan sende udfordringen videre til en ven.",
    ld_g_exchange: "Er hylderne ved at være fyldte? Byt 100 tøjdyr til en guldmønt med logobamsen. Mønten tæller som 100 præmier, så din plads på leaderboardet er uændret.",
    ld_faq_h: "Ofte stillede spørgsmål",
    ld_q1: "Er spillene gratis?",
    ld_a1: "Ja, alle femten boder er helt gratis at spille, og der er ingen køb i spillet.",
    ld_q2: "Kan jeg spille på mobil?",
    ld_a2: "Ja, spillene er bygget til mobilen: touch-styring, joystick og gyro-styring, og de virker lige så godt på tablet og computer.",
    ld_q3: "Hvilke sprog findes spillet på?",
    ld_a3: "Dansk, engelsk, tysk, italiensk, fransk og spansk. Sproget vælges automatisk efter din browser og kan altid skiftes med flag-knappen.",
    ld_q4: "Hvad kan man vinde?",
    ld_a4: "Tøjdyr i tre størrelser og guldpokaler, som samles i dit præmierum, og dine gevinster tæller på det globale leaderboard.",
    tile_punch: "Slå sækken", tile_exchange: "Bamsebørsen", ex_go: "TIL BØRSEN",
    ex_coin_one: "guldmønt", ex_coin_many: "guldmønter",
    ex_lede: "Byt {n} tøjdyr til 1 guldmønt med logobamsen. Mønten tæller som {n} præmier på tavlen, så din total er uændret. Til gengæld bliver der luft på hylderne!",
    ex_missing: "Saml {n} tøjdyr mere, så kan du bytte.",
    ex_ready: "Du har nok. Klar til at bytte!",
    ex_cta: "Byt {n} tøjdyr til 1 guldmønt",
    ex_note: "Pokaler røres aldrig. 1 guldmønt = {n} præmier på leaderboardet.",
    ex_confirm_t: "Er du sikker?",
    ex_confirm: "Du afleverer {n} tøjdyr (de mindste og ældste først) og får 1 guldmønt i præmierummet.",
    ex_yes: "Byt nu", ex_no: "Fortryd",
    ex_done_t: "Tillykke!", ex_done: "Du fik en guldmønt! Den står nu øverst i præmierummet.",
    ex_more: "Byt igen",
    pb_sign2: "0-1.000 POINT",
    pb_lede: "Fire trin, ét tryk pr. trin: gå perfekt tilbage, tag antræk, find kræfterne frem og ram plet. Op til 1.000 point, kun din egen rekord tæller.",
    pb_rule1: "1. Gå tilbage og stop på mærket (200 point)",
    pb_rule2: "2. Tag antræk med armen (200 point)",
    pb_rule3: "3. Stop poweren på toppen (300 point)",
    pb_rule4: "4. Ram sækken lige i midten (300 point)",
    pb_prizenote: "Ingen præmier her, kun ære: slå din rekord og udfordr en ven.",
    pb_best: "Rekord: {n}", pb_start: "DING DING!",
    pb_hint_walk: "Tryk når bamsen står på mærket!",
    pb_hint_windup: "Tryk på toppen af antrækket!",
    pb_hint_power: "Tryk når poweren er i det gyldne felt!",
    pb_hint_aim: "Tryk når sigtet står midt på sækken!",
    pb_ph_walk: "Afstand", pb_ph_windup: "Antræk", pb_ph_power: "Power", pb_ph_aim: "Sigte",
    pb_res_great: "KANONSLAG!", pb_res_ok: "Godt slag!", pb_res_low: "Varm op igen",
    pb_res_ko: "SÆKKEN EKSPLODEREDE!",
    pb_hs_btn: "High score",
    pb_hs_month: "Denne måned",
    pb_hs_all: "Alle tider",
    pb_hs_empty: "Ingen scores endnu",
    pb_hs_err: "Kunne ikke hente listen",
    pb_hs_close: "Luk",
    tile_duck: "Andedammen",
    dp_sign2: "FISK 10 ÆNDER",
    dp_lede: "Dyp magneten i dammen og fisk 10 ænder op. Mærket i bunden afgør præmien, og 3 ens mærker giver en bamse!",
    dp_rule1: "Grønt mærke: 3 ens = lille bamse",
    dp_rule2: "Blåt mærke: 3 ens = mellem bamse. Guldmønt: 3 ens = STOR bamse",
    dp_rule3: "Joker: giver ingenting, bedre held med næste and",
    dp_start: "FISK!",
    dp_hint: "Sigt med magneten og tryk for at fiske",
    dp_fished: "Fisket: {n}/{m}",
    dp_joker: "JOKER",
    dp_found_gron: "GRØNT MÆRKE",
    dp_found_blaa: "BLÅT MÆRKE",
    dp_found_guld: "GULDMØNT",
    dp_res_win1: "DU VANDT EN BAMSE!",
    dp_res_win: "DU VANDT {n} BAMSER!",
    dp_res_none: "INGEN BAMSER DENNE GANG",
    dp_claim: "VÆLG DINE BAMSER",
    tile_pusher: "Coin Pusher",
    pu_sign2: "100 SØLVMØNTER",
    pu_lede: "Du får 100 sølvmønter. Tim dine drop, skub mønterne over to kanter, og se hvor mange guldmønter du kan presse ud af maskinen.",
    pu_rule1: "Tryk for at slippe en mønt fra den vandrende slids",
    pu_rule2: "Sølvmønter i bakken ryger tilbage i beholdningen",
    pu_rule3: "Guld tæller på high scoren. Mønter i sidegruberne er tabt",
    pu_start: "SPIL!",
    pu_hint: "Slip mønten mens pusheren er trukket tilbage",
    pu_last: "Sidste mønter ruller...",
    pu_silver: "Sølv",
    pu_gold: "Guld",
    pu_res_title: "{n} GULDMØNTER!",
    pu_res_title1: "1 GULDMØNT!",
    pu_goldrain: "GULDREGN!",
    tile_hammer: "Styrkeprøven",
    hm_sign2: "RING MED KLOKKEN",
    hm_lede: "Tre trin med ét tryk hver: løft hammeren, find kræfterne frem og ram pladen præcist. Rammer du grønt, flyver pucken mod klokken!",
    hm_rule1: "Løft (300) og kraft (300): stop viseren i det GRØNNE felt",
    hm_rule2: "Sigte (400): jo tættere på midterstregen, jo højere flyver pucken",
    hm_rule3: "Over 900 point: klokken ringer, og du vælger en STOR bamse",
    hm_start: "SVING HAMMEREN!",
    hm_prizenote: "Kun én præmie: den STORE bamse over 900 point. Alle scores tæller på high scoren.",
    hm_ph_pull: "Løft",
    hm_ph_power: "Kraft",
    hm_ph_aim: "Sigte",
    hm_hint_pull: "Tryk når viseren står i det grønne",
    hm_hint_power: "Tryk i det grønne felt, det er bedst",
    hm_hint_aim: "Ram så tæt på midten som muligt",
    hm_bell: "KLOKKEN RINGER!",
    hm_res_great: "KÆMPE BRAG!",
    hm_res_ok: "GODT SVING!",
    hm_res_low: "PUCKEN DRILLEDE",
    hm_best: "Rekord: {n}",
    tile_bump: "Radiobiler",
    bp_sign2: "SKUB DEM UD",
    bp_lede: "Sumo i radiobiler: skub de andre ud over kanten af arenaen. Overlev til top 3 i den indledende runde, og slå de hårde bots i finalen.",
    bp_rule1: "Styr med joystikket, tryk i siderne eller piletasterne, bilen gasser selv op",
    bp_rule2: "Indledende: 6 biler, de sidste 3 går videre til finalen",
    bp_rule3: "Finalen: vinderen får GULDPOKALEN, nr. 2 og 3 en mellem bamse",
    bp_start: "START DYSTEN!",
    bp_round1: "INDLEDENDE",
    bp_final: "FINALEN",
    bp_go: "KØR!",
    bp_left: "{n} biler tilbage",
    bp_out: "{name} er ude!",
    bp_you_out: "DU RØG UD!",
    bp_qualified: "VIDERE TIL FINALEN!",
    bp_res_win: "FINALEVINDER!",
    bp_res_win_sub: "Du skubbede alle ud og vinder guldpokalen!",
    bp_res_second: "SÅ TÆT PÅ FINALESEJREN!",
    bp_res_out: "UDE I INDLEDENDE RUNDE",
    ld_g_hammer: "Klassisk styrkeprøve: tre tryk styrer løft, kraft og sigte på en bar med rødt, orange og grønt felt. Rammer du grønt hele vejen, ringer klokken, og den store bamse er din.",
    ld_g_bump: "Sumo i radiobiler: skub bots ud over kanten af den runde arena i to runder. Overlev den indledende, vind finalen mod de hårde bots, og tag guldpokalen.",
    pu_res_note: "Sølvet er brugt og maskinen står stille. Guldet tæller på high scoren.",
    ld_g_duck: "Magnetfiskeri i en levende andedam: fisk 10 ænder op og vend dem. Tre ens mærker i bunden giver en bamse, og tre guldmønt-mærker giver en STOR bamse.",
    ld_g_pusher: "Klassisk mønt-maskine i to lag: 100 sølvmønter, oscillerende pushere og guldmønter, der venter ved kanten. Sølv i bakken kan skydes igen, guldet tæller på high scoren.",
    pb_challenge: "Udfordr en ven", pb_copied: "Linket er kopieret!",
    pb_share_text: "Jeg fik {n} point i Slå sækken i Teddy Chase. Slå det!",
    hm_share_text: "Jeg fik {n} point i Styrkeprøven i Teddy Chase. Slå det!",
    pb_ch_banner: "{name} udfordrer dig: {n} point. Slå det!",
    pb_ch_beat: "Du slog {name}!", pb_ch_lost: "{name} fører stadig med {n} point.",
    size_lille: "Lille", size_mellem: "Mellemstor", size_stor: "Stor",
    color_neonpink: "Rosa", color_giftgroen: "Lysegrøn", color_elblaa: "Himmelblå",
    color_neonorange: "Orange", color_skriggul: "Solgul", color_neonlilla: "Lavendel",
    color_turkis: "Mint", color_knaldroed: "Koralrød",
    type_bamse: "Bamse", type_enhjoerning: "Enhjørning", type_dino: "Dinosaur",
    type_blaeksprutte: "Blæksprutte", type_froe: "Frø", type_kanin: "Kanin",
    type_panda: "Panda", type_loeve: "Løve", type_elefant: "Elefant",
    type_pingvin: "Pingvin", type_haj: "Haj", type_koala: "Koala",
    type_hund: "Tøjhund", type_giraf: "Giraf", type_bjoern: "Bjørn",
    trophy: "Guldpokal",
    // prize picker
    pp_ribbon: "PRÆMIE!",
    pp_won: "Du har vundet et {size} tøjdyr, vælg selv hvilket:",
    // prize room
    pr_title: "PRÆMIERUM",
    pr_count_one: "præmie", pr_count_many: "præmier",
    pr_tip: "Hold på et tøjdyr og træk det for at flytte rundt",
    pr_empty: "Hylderne er tomme…",
    pr_empty2: "Vind dit første tøjdyr!",
    // leaderboard
    lb_title: "LEADERBOARD",
    lb_name: "Navn", lb_trophies: "Pokaler", lb_plush: "Bamser", lb_total: "Total",
    lb_empty: "Ingen på tavlen endnu, ud og vind!",
    lb_note: "Globalt",
    lb_loading: "Henter stillingen…",
    lb_offline: "Kunne ikke hente det globale leaderboard, tjek din forbindelse.",
    name_device_note: "Denne enhed har én plads på det globale leaderboard, et nyt navn overtager pladsen.",
    // horse race
    h_sign2: "2 KUGLER AD GANGEN",
    h_lede: "Tag kuglerne fra bakken og læg dem på startlinjen, placeringen bestemmer din vinkel! Rul dem op ad rampen og flyv over kanten: hvert hul rykker din hest mod mål. Først til {goal} vinder løbet og en præmie!",
    h_opponents: "Modstandere",
    h_difficulty: "Sværhedsgrad",
    diff_let: "Let", diff_mellem: "Mellem", diff_svaer: "Svær",
    h_track_let: "Banen: Den Klassiske, åben plade og frit sigte mod den røde 3'er",
    h_track_mellem: "Banen: Dobbelt-Guld. TO røde 3'ere bagerst i hjørnerne, hver vogtet af en pind",
    h_track_svaer: "Banen: Vogteren, tre pinde spærrer det direkte skud mod rød (flyv over eller bank udenom!)",
    h_prizenote: "Præmier: Let = små · Mellem = små og mellemstore · Svær = alle, og jo flere modstandere, jo større chance for de STORE!",
    h_start: "Start løbet",
    h_legend_red: "Rød = 3", h_legend_blue: "Blå = 2", h_legend_yellow: "Gul = 1",
    h_yourhorse: "Din hest:",
    h_last: "Sidste kugle: +{pts}",
    h_win: "DU VANDT!", h_lose: "LØBET ER SLUT",
    h_wonrace: "vandt løbet!",
    h_noprize: "Ingen præmie denne gang, prøv igen!",
    h_points: "point",
    h_hint_take: "Tag en kugle fra bakken og læg den mellem linjerne",
    h_hint_move: "Flyt kuglen frit, træk bagud for at skyde!",
    // football
    f_sign2: "{shots} SKUD, {need} MÅL = PRÆMIE",
    f_lede: "Du har {shots} skud mod målmanden, han glider frem og tilbage, men kan ikke nå hjørnerne. Træk i en bue for at skrue bolden udenom!",
    f_rule1: "{shots} skud, mindst {need} mål giver præmie",
    f_rule2: "Målmanden rykker sig, finter efter 2 mål, hurtigere efter 3, og på sidste skud giver han ALT!",
    f_rule3: "Skru: træk fingeren i en bue, så bøjer skuddet",
    f_rule4: "Fuld kraft (rød måler) = risiko for overliggeren!",
    f_prizenote: "Præmie efter antal mål: 3-4 = lille · 5 = mellemstor · 6-7 = STOR · alle 8 = GULDPOKAL!",
    f_start: "Fløjt kampen i gang",
    f_goals: "Mål:", f_shots: "Skud {n} / {max}",
    f_win: "SIKKE EN FOD!", f_fail: "MÅLMANDEN VANDT!",
    f_winline: "{goals} mål på {shots} skud!",
    f_failline: "{goals} mål på {shots} skud, der skulle {need} til. Prøv igen!",
    f_trophy_ribbon: "GULDPOKAL!",
    f_trophyline: "Alle {shots} mål! Guldpokalen står nu på øverste hylde i præmierummet!",
    f_hint: "Tag en bold, træk i en bue for at skrue!",
    f_banner: "{shots} SKUD. MINDST {need} MÅL!",
    f_hattrick: "HAT-TRICK!",
    f_hattrick2: "DOBBELT HAT-TRICK!",
    f_hattrick_sub: "{n} MÅL • {n} SKUD",
    f_curve: "SKRU",
    tray_empty: "TOM",
    // basketball
    b_sign2: "3 LEVELS MOD URET",
    b_lede: "Tiden er din modstander! Du har 30 sekunder pr. level: ram kurven {n1}, så {n2} og i finalen {n3} gange. Kurven flytter sig på level 2 og i finalen!",
    b_rule1: "Level 1, ram {n} på 30 sek. (kurven står stille)",
    b_rule2: "Level 2, ram {n} på 30 sek. (kurven glider)",
    b_rule3: "Finalen, ram {n} på 30 sek. (kurven glider hurtigt, og du får en ekstra bold!)",
    b_prizenote: "Præmie: Gennemfør alle tre levels og vind et mellemstort tøjdyr, altid, i denne bod.",
    b_start: "Start uret",
    b_level: "Level", b_final: "Finalen",
    b_of: "Level {n} af {max}",
    b_win: "DU KLAREDE URET!",
    b_winline: "Alle {n} levels gennemført!",
    b_fail: "TIDEN LØB UD!",
    b_failline: "Du nåede {level}, ingen præmie denne gang.",
    b_hint: "Tag en bold fra bakken og læg den mellem linjerne",
    b_banner1: "RAM {n} PÅ 30 SEK!",
    b_banner2: "{level}. RAM {n} PÅ 30 SEK!",
    b_banner3: "FINALEN. RAM {n} · EKSTRA BOLD!",
    // shooting gallery
    s_sign2: "{shots} SKUD. RAM MONSTRENE",
    s_lede: "Monstrene stryger forbi i tre rækker, jo længere væk, jo hurtigere! Du har {shots} skud. Ram så mange du kan!",
    s_rule1: "{shots} skud, ram 7 monstre for en lille bamse",
    s_rule2: "8 ramte = mellemstor bamse · 9 = STOR bamse",
    s_rule3: "Græskarrene bagerst popper op igen, resten bliver nede!",
    s_rule4: "Alle 10 = GULDPOKAL!",
    s_trophy_ribbon: "GULDPOKAL!",
    s_trophyline: "Alle {shots} monstre ramt! Guldpokalen står nu på øverste hylde i præmierummet!",
    s_prizenote: "Kuglen rammer det første monster på sin vej, sigt efter de hurtige rækker, når du tør!",
    s_start: "Klar, sigt, skyd",
    s_hits: "Ramt:", s_shots: "Skud {n} / {max}",
    s_win: "SIKKE ET SIGTE!",
    s_fail: "MONSTRENE SLAP VÆK!",
    s_winline: "{hits} af {shots} monstre ramt!",
    s_failline: "Kun {hits} ramt, der skulle 7 til. Prøv igen!",
    s_hint: "Tag en kugle og skyd efter monstrene!",
    s_banner: "RAM MONSTRENE!",
    // claw machine
    tile_claw: "Klomaskinen",
    c_sign2: "3 FORSØG PR. 15 MIN",
    c_lede: "Kloen kører frem og tilbage over bunken, tryk, når den er over dit udvalgte tøjdyr, og kryds fingre for et godt greb!",
    c_rule1: "Tryk for at slippe kloen",
    c_rule2: "Rammer du rent, følger tøjdyret med op",
    c_rule3: "3 forsøg pr. kvarter, så maskinen ikke tømmes",
    c_prizenote: "Gevinst: det lille tøjdyr du fisker op, præcis som du ser det!",
    c_start: "Start maskinen",
    c_tries: "Forsøg: {n} / 3",
    c_wait: "Næste forsøg om {t}",
    c_hint: "Tryk for at slippe kloen!",
    c_locked: "Maskinen hviler sig, kom tilbage om {t}",
    c_win: "SIKKE ET GREB!",
    c_missline: "Kloen slap sit tag… prøv igen!",
    c_done_won: "Du fiskede {n} tøjdyr, de står nu i præmierummet!",
    c_done_won1: "Du fiskede 1 tøjdyr, det står nu i præmierummet!",
    c_done_zero_title: "TOMT GREB!",
    c_done_zero: "Kloen fik ikke fat i noget denne gang, bedre held næste gang!",
    // rewarded ads (fælles ad_-præfiks)
    ad_offer_claw: "Kloen lades op… eller se en kort video og få 6 nye forsøg med det samme!",
    ad_watch: "Se video",
    ad_no: "Nej tak",
    ad_fail: "Videoen kunne ikke vises, prøv igen senere.",
    ad_bonus: "+{n} bonusforsøg",
    ad_label: "Annonce",
    doc_title: "Teddy Chase – sjove gratis spil: hestevæddeløb, klomaskine m.fl.",
    ad_offer_double: "Dobbelt op! Se en kort video og gør din præmie {size}.",
    ad_upgraded: "Præmien er opgraderet, vælg dit tøjdyr!",
    ad_offer_cans_title: "SÅ TÆT PÅ!",
    ad_offer_cans: "{n} dåser tilbage, se en kort video og få 1 ekstra bold!",
    ad_offer_football: "Ét mål fra en bedre præmie! Se en kort video og få 1 ekstra skud.",
    ad_offer_shoot: "Ét træf fra en bedre præmie! Se en kort video og få 1 ekstra skud.",
    ad_offer_basket: "Se en kort video og prøv {level} igen med uret nulstillet!",
    pop_grab: "GREB!", pop_slip: "SLAP!",
    // lucky wheel
    tile_wheel: "Lykkehjulet",
    w_sign2: "GÆT 3 AF 20 TAL",
    w_lede: "Vælg 3 tal og drej det store hjul, lander pilen på et af dine tal, vinder du et mellemstort tøjdyr! Tallene har samme farve som deres felt på hjulet.",
    w_pick: "Vælg {n} tal endnu",
    w_ready: "Klar til at dreje!",
    w_spin: "DREJ HJULET",
    w_spinning: "Hjulet drejer…",
    w_win: "LYKKENS TAL!",
    w_winline: "Hjulet landede på {n}, et af dine tal!",
    w_lose: "IKKE DENNE GANG",
    w_loseline: "Hjulet landede på {n}. Vælg tal og prøv igen!",
    w_prizenote1: "Gevinst: et mellemstort tøjdyr",
    w_prizenote2: "3 ud af 20, held følger de modige!",
    // Racerbiler
    tile_race: "Racerbiler",
    rc_sign2: "FØRST TIL {laps} OMGANGE",
    rc_lede: "Radiobil-ræs set fra oven! Styr bilen rundt på ovalen, saml boosts op og skub gerne til de andre, først til {laps} omgange vinder.",
    rc_rule1: "Styr med joysticket i hjørnet (eller piletasterne)",
    rc_rule2: "Kør over et boost-felt og få et ordentligt skub fremad",
    rc_rule3: "Sammenstød er tilladt, skub modstanderne ud i sværene!",
    rc_prizenote: "Let = lille · Mellem = mellemstor · Svær = GULDPOKAL",
    rc_start: "START LØBET",
    rc_ready: "KLAR…",
    rc_go: "GO!",
    rc_track: "Bane",
    rc_track_oval: "Oval", rc_track_heart: "Hjertebanen", rc_track_tri: "Trekant",
    rc_lap: "Omgang {n}/{max}",
    rc_lapup: "OMGANG {n}/{max}",
    rc_pos: "Nr. {n}",
    rc_boost: "BOOST!",
    rc_win: "SEJR!",
    rc_winline: "1. pladsen, du vandt løbet!",
    rc_finishpop: "I MÅL!",
    rc_trophy_ribbon: "MESTERPOKAL!",
    rc_trophyline: "Du vandt på Svær, pokalen står nu i præmierummet!",
    rc_fail: "MÅLFLAG",
    rc_failline: "Du kørte i mål som nr. {n}, bag rattet igen!",
    // Hangtime
    tile_hang: "Hangtime",
    ht_sign2: "HOLD BALANCEN",
    ht_lede: "Linedanseren går på slap line højt over manegen. Hold pilen i det grønne felt, vipper han for langt, ryger han i nettet! Vinden gør det sværere og sværere.",
    ht_rule1: "Hold pilen i det grønne felt på måleren",
    ht_rule2: "Pas på vindstødene, de kommer fra begge sider",
    ht_rule3_mouse: "Flyt musen til siderne for at læne ham, eller brug piletasterne",
    ht_rule3_touch: "Vip telefonen for at læne, eller hold i siderne af skærmen",
    ht_prizenote: "{lille}s=lille · {mellem}s=mellemstor · {stor}s=stor · {pokal}s=GULDPOKAL",
    ht_start_mouse: "PÅ LINEN",
    ht_start_gyro: "SPIL MED TILT",
    ht_start_touch: "Spil med tryk i siderne",
    ht_mode_gyro: "TILT",
    ht_mode_mouse: "MUS",
    ht_mode_touch: "TRYK",
    ht_gyro_denied: "Kunne ikke få adgang til telefonens tilt, brug tryk-styring i stedet.",
    ht_crossings: "Ture: {n}",
    ht_cross: "TUR {n}!",
    ht_win: "SIKKE EN BALANCE!",
    ht_winline: "Du holdt dig oppe i {s} sekunder!",
    ht_trophy_ribbon: "LINEDANSER-LEGENDE!",
    ht_trophyline: "{s} sekunder på linen, pokalen står nu i præmierummet!",
    ht_fail: "I NETTET",
    ht_failline: "{s} sekunder, du skal holde {need} for en præmie. Op på linen igen!",
    // Ram dåserne
    tile_cans: "Ram dåserne",
    cn_sign2: "{shots} KAST",
    cn_lede: "Ti blikdåser i en pyramide, vælt HELE tårnet ned fra bordet på højst {shots} kast! Jo færre kast, jo bedre præmie.",
    cn_rule1: "Træk NED og slip for at kaste bolden op mod tårnet",
    cn_rule2: "Dåserne tæller først, når de er HELT nede fra bordet",
    cn_rule3: "Fuld kraft er ikke altid bedst, sigt efter bunden!",
    cn_prizenote: "2 kast = GULDPOKAL · 3 = stor · 4 = mellemstor · 5 = lille",
    cn_start: "KAST LØS",
    cn_cans: "Dåser tilbage: {n}",
    cn_shots: "Kast {n}/{max}",
    cn_out: "UD!",
    cn_win: "TÅRNET FALDT!",
    cn_winline: "Alle 10 dåser røg ned på {n} kast!",
    cn_trophy_ribbon: "DÅSE-KONGE!",
    cn_trophyline: "Hele tårnet på bare {n} kast, pokalen er din!",
    cn_fail: "TÅRNET STÅR",
    cn_failline: "{n} dåser overlevede, nyt tårn, nye chancer!",
    // Slå muldvarpen
    tile_mole: "Slå muldvarpen",
    mo_sign2: "{s} SEKUNDER",
    mo_lede: "Muldvarpene myldrer op af hullerne, slå dem, før de dykker ned igen! Du har {s} sekunder, og det går hurtigere og hurtigere.",
    mo_rule1: "Tryk på muldvarpene, mens de er oppe",
    mo_rule2: "Gyldne muldvarpe giver 3 point",
    mo_rule3: "Tempoet stiger, hold hovedet koldt til sidst",
    mo_prizenote: "{lille}=lille · {mellem}=mellemstor · {stor}=stor · {pokal}=GULDPOKAL",
    mo_start: "START JAGTEN",
    mo_hits: "Slået: {n}",
    mo_win: "SIKKE EN JAGT!",
    mo_winline: "Du slog {n} muldvarpe!",
    mo_trophy_ribbon: "MULDVARPE-MESTER!",
    mo_trophyline: "{n} muldvarpe på tiden, pokalen står nu i præmierummet!",
    mo_fail: "DE SLAP VÆK",
    mo_failline: "Du slog {n}, du skal bruge mindst {need} for en præmie. Prøv igen!",
    // CPU-navnepuljer (trækkes tilfældigt pr. løb via sampleNames)
    names_horse: ["Stormvind", "Sukkermule", "Baron von Trav", "Frøken Fart", "Gyldenhov", "Prins Prust", "Madam Mule", "Lyn-Laura", "Havre-Helge", "Grev Galop"],
    names_race: ["Gas-Gert", "Fru Fælg", "Turbo-Tut", "Benzino", "Oktan-Ole", "Dæk-Dan", "Fart-Finn", "Nitro-Nis", "Bremse-Bo", "Olie-Otto"],
    // canvas popups
    pop_goal: "MÅL!", pop_saved: "REDDET!", pop_post: "STOLPE!", pop_over: "OVERLIGGER!",
    pop_basket: "KURV!", pop_hit: "RAMT!",
  },
  en: {
    menu_welcome: "WELCOME TO THE BOOTH",
    menu_allwin: "EVERYONE CAN WIN",
    play: "PLAY",
    tile_horse: "Horse Race",
    tile_football: "Football",
    tile_basket: "Basketball",
    tile_shoot: "Shooting Gallery",
    tile_prizes: "Prize Room",
    tile_board: "Leaderboard",
    prizes_one: "PRIZE",
    prizes_many: "PRIZES",
    board_go: "VIEW BOARD",
    footer_privacy: "Privacy",
    name_q: "What's your name?",
    name_note: "Your name is shown on the leaderboard and at the race track. A nickname is a good idea, it can be seen by all players.",
    name_ph: "Your name",
    name_save: "SAVE",
    name_err_len: "The name must be 2-12 characters.",
    name_err_rude: "We can't engrave that on a trophy… try another.",
    back: "‹ Menu",
    sign_free: "FREE",
    play_again: "Play again",
    try_again: "Try again",
    to_menu: "Back to menu",
    your_prize: "Your prize:",
    in_room: "– it's now in your prize room!",
    you: "You",
    ld_h1: "Teddy Chase – classic fairground booths and fun games online",
    ld_intro: "Teddy Chase is a free collection of fifteen classic fairground booths you can play right in your browser, on mobile, tablet and desktop, with no downloads and no purchases. Win plushies in happy colours and shiny gold trophies, fill your prize room and fight for a spot on the global leaderboard. The game is available in six languages: Danish, English, German, Italian, French and Spanish.",
    ld_g_horse: "The king of the booths: roll balls up the ramp and hit the holes, every point moves your horse towards the finish. Three tracks, blocker pins and up to five opponents.",
    ld_g_claw: "A classic claw machine online: tap at the right moment and grab exactly the plushie you see in the pile. Three tries per quarter hour, so make them count.",
    ld_g_shoot: "A shooting gallery like the real fairground: three rows of moving monsters, hit 7 for a prize, hit all 10 and take the gold trophy.",
    ld_g_wheel: "Pick 3 of the wheel's 20 numbers and spin. If the pointer lands on your number, the medium plushie is yours.",
    ld_g_race: "Top-down radio car racing with a joystick, boosts and elbows, three tracks, five laps, and a gold trophy for winning on Hard.",
    ld_g_football: "Eight shots against a keeper who feints and escalates. Curl the ball around him, eight goals in a row earns the trophy, with hat-trick celebrations along the way.",
    ld_g_basket: "Three levels against the clock with a hoop that slides faster and faster. Clear the final and pick your plushie.",
    ld_g_mole: "60 seconds, nine holes and moles popping ever faster, the golden ones score three points, and the peekers are almost impossible to catch.",
    ld_g_cans: "Can toss with real physics: knock the whole pyramid off the table in five throws. Do it in two and the gold trophy is waiting.",
    ld_g_hang: "Keep the tightrope walker balanced in the wind with your mouse, arrow keys or by tilting your phone. The longer you last, the bigger the prize.",
    ld_g_punch: "Four steps, one tap each: walk back perfectly, wind up, nail the power and fly into the punching bag. Up to 1,000 points, and you can send the challenge on to a friend.",
    ld_g_exchange: "Shelves getting full? Trade 100 plushies for a gold coin with the logo teddy. The coin counts as 100 prizes, so your leaderboard spot stays the same.",
    ld_faq_h: "Frequently asked questions",
    ld_q1: "Are the games free?",
    ld_a1: "Yes, all fifteen booths are completely free to play, and there are no in-game purchases.",
    ld_q2: "Can I play on mobile?",
    ld_a2: "Yes, the games are built for mobile: touch controls, joystick and gyro, and they work just as well on tablet and desktop.",
    ld_q3: "Which languages is the game available in?",
    ld_a3: "Danish, English, German, Italian, French and Spanish. The language is picked automatically from your browser and can always be changed with the flag button.",
    ld_q4: "What can you win?",
    ld_a4: "Plushies in three sizes and gold trophies, collected in your prize room, and your winnings count on the global leaderboard.",
    tile_punch: "Punch a Bag", tile_exchange: "Teddy Exchange", ex_go: "TRADE",
    ex_coin_one: "gold coin", ex_coin_many: "gold coins",
    ex_lede: "Trade {n} plushies for 1 gold coin with the logo teddy. The coin counts as {n} prizes on the board, so your total stays the same. But your shelves get room to breathe!",
    ex_missing: "Collect {n} more plushies to trade.",
    ex_ready: "You have enough. Ready to trade!",
    ex_cta: "Trade {n} plushies for 1 gold coin",
    ex_note: "Trophies are never touched. 1 gold coin = {n} prizes on the leaderboard.",
    ex_confirm_t: "Are you sure?",
    ex_confirm: "You hand in {n} plushies (smallest and oldest first) and get 1 gold coin in the prize room.",
    ex_yes: "Trade now", ex_no: "Cancel",
    ex_done_t: "Congratulations!", ex_done: "You got a gold coin! It now sits at the top of the prize room.",
    ex_more: "Trade again",
    pb_sign2: "0-1,000 POINTS",
    pb_lede: "Four steps, one tap each: walk back perfectly, wind up your arm, nail the power and hit dead centre. Up to 1,000 points, only your own record counts.",
    pb_rule1: "1. Walk back and stop on the mark (200 points)",
    pb_rule2: "2. Wind up your arm (200 points)",
    pb_rule3: "3. Stop the power at the top (300 points)",
    pb_rule4: "4. Hit the bag dead centre (300 points)",
    pb_prizenote: "No prizes here, just glory: beat your record and challenge a friend.",
    pb_best: "Best: {n}", pb_start: "DING DING!",
    pb_hint_walk: "Tap when the teddy is on the mark!",
    pb_hint_windup: "Tap at the top of the wind-up!",
    pb_hint_power: "Tap when the power is in the golden zone!",
    pb_hint_aim: "Tap when the sight is centred on the bag!",
    pb_ph_walk: "Distance", pb_ph_windup: "Wind-up", pb_ph_power: "Power", pb_ph_aim: "Aim",
    pb_res_great: "KNOCKOUT!", pb_res_ok: "Nice hit!", pb_res_low: "Warm up again",
    pb_res_ko: "THE BAG EXPLODED!",
    pb_hs_btn: "High scores",
    pb_hs_month: "This month",
    pb_hs_all: "All time",
    pb_hs_empty: "No scores yet",
    pb_hs_err: "Could not load the list",
    pb_hs_close: "Close",
    tile_duck: "Duck Pond",
    dp_sign2: "HOOK 10 DUCKS",
    dp_lede: "Dip the magnet into the pond and hook 10 ducks. The mark underneath decides the prize, and 3 matching marks win a teddy!",
    dp_rule1: "Green mark: 3 of a kind = small teddy",
    dp_rule2: "Blue mark: 3 of a kind = medium teddy. Gold coin: 3 of a kind = BIG teddy",
    dp_rule3: "Joker: wins nothing, better luck with the next duck",
    dp_start: "GO FISHING!",
    dp_hint: "Aim the magnet and tap to fish",
    dp_fished: "Hooked: {n}/{m}",
    dp_joker: "JOKER",
    dp_found_gron: "GREEN MARK",
    dp_found_blaa: "BLUE MARK",
    dp_found_guld: "GOLD COIN",
    dp_res_win1: "YOU WON A TEDDY!",
    dp_res_win: "YOU WON {n} TEDDIES!",
    dp_res_none: "NO TEDDIES THIS TIME",
    dp_claim: "PICK YOUR TEDDIES",
    tile_pusher: "Coin Pusher",
    pu_sign2: "100 SILVER COINS",
    pu_lede: "You get 100 silver coins. Time your drops, push the coins over two edges, and see how many gold coins you can squeeze out of the machine.",
    pu_rule1: "Tap to release a coin from the moving slot",
    pu_rule2: "Silver coins in the tray go back into your stack",
    pu_rule3: "Gold counts on the high score. Coins in the side gutters are lost",
    pu_start: "PLAY!",
    pu_hint: "Release the coin while the pusher is pulled back",
    pu_last: "Last coins rolling...",
    pu_silver: "Silver",
    pu_gold: "Gold",
    pu_res_title: "{n} GOLD COINS!",
    pu_res_title1: "1 GOLD COIN!",
    pu_goldrain: "GOLD RAIN!",
    tile_hammer: "High Striker",
    hm_sign2: "RING THE BELL",
    hm_lede: "Three steps, one tap each: raise the hammer, charge your power and hit the pad dead centre. Land in the green and the puck flies for the bell!",
    hm_rule1: "Lift (300) and power (300): stop the needle in the GREEN zone",
    hm_rule2: "Aim (400): the closer to the centre line, the higher the puck flies",
    hm_rule3: "Above 900 points the bell rings and you pick a BIG teddy",
    hm_start: "SWING THE HAMMER!",
    hm_prizenote: "One prize only: the BIG teddy above 900 points. Every score counts on the high score.",
    hm_ph_pull: "Lift",
    hm_ph_power: "Power",
    hm_ph_aim: "Aim",
    hm_hint_pull: "Tap when the needle is in the green",
    hm_hint_power: "Tap in the green zone, that is best",
    hm_hint_aim: "Hit as close to the centre as you can",
    hm_bell: "THE BELL RINGS!",
    hm_res_great: "HUGE HIT!",
    hm_res_ok: "GOOD SWING!",
    hm_res_low: "THE PUCK GOT SHY",
    hm_best: "Best: {n}",
    tile_bump: "Bumper Cars",
    bp_sign2: "PUSH THEM OUT",
    bp_lede: "Bumper car sumo: shove the others over the edge of the arena. Survive to the top 3 in the opening round, then beat the tough bots in the final.",
    bp_rule1: "Steer with the joystick, side taps or arrow keys, the car accelerates by itself",
    bp_rule2: "Opening round: 6 cars, the last 3 advance to the final",
    bp_rule3: "The final: the winner takes the GOLD TROPHY, 2nd and 3rd get a medium teddy",
    bp_start: "START THE DUEL!",
    bp_round1: "OPENING ROUND",
    bp_final: "THE FINAL",
    bp_go: "GO!",
    bp_left: "{n} cars left",
    bp_out: "{name} is out!",
    bp_you_out: "YOU FELL OUT!",
    bp_qualified: "THROUGH TO THE FINAL!",
    bp_res_win: "FINAL WINNER!",
    bp_res_win_sub: "You pushed everyone out and win the gold trophy!",
    bp_res_second: "SO CLOSE TO THE TITLE!",
    bp_res_out: "OUT IN THE OPENING ROUND",
    ld_g_hammer: "A classic high striker: three taps control lift, power and aim on a red, orange and green bar. Hit green all the way, the bell rings and the big teddy is yours.",
    ld_g_bump: "Bumper car sumo: push bots over the edge of the round arena across two rounds. Survive the opener, win the final against the tough bots and take the gold trophy.",
    pu_res_note: "The silver is spent and the machine is still. Your gold counts on the high score.",
    ld_g_duck: "Magnet fishing in a living duck pond: hook 10 ducks and flip them over. Three matching marks underneath win a teddy, and three gold-coin marks win a BIG teddy.",
    ld_g_pusher: "A classic two-tier coin pusher: 100 silver coins, oscillating pushers and gold coins waiting at the edge. Silver in the tray can be dropped again, gold counts on the high score.",
    pb_challenge: "Challenge a friend", pb_copied: "Link copied!",
    pb_share_text: "I scored {n} points on Punch a Bag in Teddy Chase. Beat it!",
    hm_share_text: "I scored {n} points on the High Striker in Teddy Chase. Beat it!",
    pb_ch_banner: "{name} challenges you: {n} points. Beat it!",
    pb_ch_beat: "You beat {name}!", pb_ch_lost: "{name} still leads with {n} points.",
    size_lille: "Small", size_mellem: "Medium", size_stor: "Big",
    color_neonpink: "Rose pink", color_giftgroen: "Light green", color_elblaa: "Sky blue",
    color_neonorange: "Warm orange", color_skriggul: "Sunny yellow", color_neonlilla: "Lavender",
    color_turkis: "Mint", color_knaldroed: "Coral red",
    type_bamse: "Teddy", type_enhjoerning: "Unicorn", type_dino: "Dinosaur",
    type_blaeksprutte: "Octopus", type_froe: "Frog", type_kanin: "Bunny",
    type_panda: "Panda", type_loeve: "Lion", type_elefant: "Elephant",
    type_pingvin: "Penguin", type_haj: "Shark", type_koala: "Koala",
    type_hund: "Puppy", type_giraf: "Giraffe", type_bjoern: "Bear",
    trophy: "Gold trophy",
    pp_ribbon: "PRIZE!",
    pp_won: "You've won a {size} plush toy, pick your favourite:",
    pr_title: "PRIZE ROOM",
    pr_count_one: "prize", pr_count_many: "prizes",
    pr_tip: "Press and hold a plush to move it around",
    pr_empty: "The shelves are empty…",
    pr_empty2: "Go win your first plush!",
    lb_title: "LEADERBOARD",
    lb_name: "Name", lb_trophies: "Trophies", lb_plush: "Plushies", lb_total: "Total",
    lb_empty: "Nobody on the board yet, go win!",
    lb_note: "Global",
    lb_loading: "Fetching the standings…",
    lb_offline: "Couldn't load the global leaderboard, check your connection.",
    name_device_note: "This device has one spot on the global leaderboard, a new name takes over that spot.",
    h_sign2: "2 BALLS AT A TIME",
    h_lede: "Take the balls from the tray and place them on the start line, placement sets your angle! Roll them up the ramp and fly over the edge: every hole moves your horse. First to {goal} wins the race and a prize!",
    h_opponents: "Opponents",
    h_difficulty: "Difficulty",
    diff_let: "Easy", diff_mellem: "Medium", diff_svaer: "Hard",
    h_track_let: "Track: The Classic, open board and a clear shot at the red 3",
    h_track_mellem: "Track: Double Gold. TWO red 3s in the back corners, each guarded by a peg",
    h_track_svaer: "Track: The Guardian, three pegs block the straight shot at red (fly over or bank around!)",
    h_prizenote: "Prizes: Easy = small · Medium = small & medium · Hard = all, and the more opponents, the better your shot at the BIG ones!",
    h_start: "Start the race",
    h_legend_red: "Red = 3", h_legend_blue: "Blue = 2", h_legend_yellow: "Yellow = 1",
    h_yourhorse: "Your horse:",
    h_last: "Last ball: +{pts}",
    h_win: "YOU WON!", h_lose: "THE RACE IS OVER",
    h_wonrace: "won the race!",
    h_noprize: "No prize this time, try again!",
    h_points: "points",
    h_hint_take: "Take a ball from the tray and place it between the lines",
    h_hint_move: "Move the ball freely, drag back to shoot!",
    f_sign2: "{shots} SHOTS, {need} GOALS = PRIZE",
    f_lede: "You have {shots} shots against the keeper, he slides back and forth but can't reach the corners. Drag in a curve to bend it around him!",
    f_rule1: "{shots} shots, at least {need} goals wins a prize",
    f_rule2: "The keeper moves, feints after 2 goals, speeds up after 3, and gives EVERYTHING on the last shot!",
    f_rule3: "Curve: drag your finger in an arc to bend the shot",
    f_rule4: "Full power (red meter) = risk of the crossbar!",
    f_prizenote: "Prize by goals: 3-4 = small · 5 = medium · 6-7 = BIG · all 8 = GOLD TROPHY!",
    f_start: "Kick off",
    f_goals: "Goals:", f_shots: "Shot {n} / {max}",
    f_win: "WHAT A FOOT!", f_fail: "THE KEEPER WON!",
    f_winline: "{goals} goals in {shots} shots!",
    f_failline: "{goals} goals in {shots} shots, you needed {need}. Try again!",
    f_trophy_ribbon: "GOLD TROPHY!",
    f_trophyline: "All {shots} goals! The gold trophy now sits on the top shelf of your prize room!",
    f_hint: "Take a ball, drag in an arc for curve!",
    f_banner: "{shots} SHOTS. AT LEAST {need} GOALS!",
    f_hattrick: "HAT-TRICK!",
    f_hattrick2: "DOUBLE HAT-TRICK!",
    f_hattrick_sub: "{n} GOALS • {n} SHOTS",
    f_curve: "CURVE",
    tray_empty: "EMPTY",
    b_sign2: "3 LEVELS VS THE CLOCK",
    b_lede: "Time is your opponent! You get 30 seconds per level: hit the hoop {n1}, then {n2}, and {n3} times in the final. The hoop moves on level 2 and the final!",
    b_rule1: "Level 1, hit {n} in 30 sec. (the hoop stands still)",
    b_rule2: "Level 2, hit {n} in 30 sec. (the hoop slides)",
    b_rule3: "The Final, hit {n} in 30 sec. (fast hoop, and you get an extra ball!)",
    b_prizenote: "Prize: Clear all three levels and win a medium plush, always, at this booth.",
    b_start: "Start the clock",
    b_level: "Level", b_final: "The Final",
    b_of: "Level {n} of {max}",
    b_win: "YOU BEAT THE CLOCK!",
    b_winline: "All {n} levels cleared!",
    b_fail: "TIME'S UP!",
    b_failline: "You reached {level}, no prize this time.",
    b_hint: "Take a ball from the tray and place it between the lines",
    b_banner1: "HIT {n} IN 30 SEC!",
    b_banner2: "{level}. HIT {n} IN 30 SEC!",
    b_banner3: "THE FINAL. HIT {n} · EXTRA BALL!",
    s_sign2: "{shots} SHOTS. HIT THE MONSTERS",
    s_lede: "The monsters sweep past in three rows, the further away, the faster! You have {shots} shots. Hit as many as you can!",
    s_rule1: "{shots} shots, hit 7 monsters for a small plush",
    s_rule2: "8 hits = medium plush · 9 = BIG plush",
    s_rule3: "The back-row pumpkins pop back up, everything else stays down!",
    s_rule4: "All 10 = GOLD TROPHY!",
    s_trophy_ribbon: "GOLD TROPHY!",
    s_trophyline: "All {shots} monsters hit! The gold trophy now sits on the top shelf of your prize room!",
    s_prizenote: "The ball hits the first monster in its path, aim for the fast rows when you dare!",
    s_start: "Ready, aim, fire",
    s_hits: "Hits:", s_shots: "Shot {n} / {max}",
    s_win: "WHAT AN AIM!",
    s_fail: "THE MONSTERS GOT AWAY!",
    s_winline: "{hits} of {shots} monsters hit!",
    s_failline: "Only {hits} hit, you needed 7. Try again!",
    s_hint: "Take a ball and shoot the monsters!",
    s_banner: "HIT THE MONSTERS!",
    // claw machine
    tile_claw: "Claw Machine",
    c_sign2: "3 TRIES PER 15 MIN",
    c_lede: "The claw sweeps back and forth over the pile, tap when it's above your favourite plush and cross your fingers for a good grip!",
    c_rule1: "Tap to drop the claw",
    c_rule2: "A clean hit brings the plush up with it",
    c_rule3: "3 tries per quarter hour, so the machine doesn't get emptied",
    c_prizenote: "Prize: the small plush you fish up, exactly as you see it!",
    c_start: "Start the machine",
    c_tries: "Tries: {n} / 3",
    c_wait: "Next try in {t}",
    c_hint: "Tap to drop the claw!",
    c_locked: "The machine is resting, come back in {t}",
    c_win: "WHAT A GRAB!",
    c_done_won: "You fished {n} plushies, they're now in your prize room!",
    c_done_won1: "You fished 1 plushie, it's now in your prize room!",
    c_done_zero_title: "EMPTY CLAW!",
    c_done_zero: "The claw came up empty this time, better luck next time!",
    // rewarded ads (shared ad_ prefix)
    ad_offer_claw: "The claw is recharging… or watch a short video and get 6 new tries right away!",
    ad_watch: "Watch video",
    ad_no: "No thanks",
    ad_fail: "The video couldn't be shown, please try again later.",
    ad_bonus: "+{n} bonus tries",
    ad_label: "Ad",
    doc_title: "Teddy Chase – fun free games: horse race, claw machine & more",
    ad_offer_double: "Double up! Watch a short video and make your prize {size}.",
    ad_upgraded: "Prize upgraded, pick your plushie!",
    ad_offer_cans_title: "SO CLOSE!",
    ad_offer_cans: "{n} cans left, watch a short video and get 1 extra ball!",
    ad_offer_football: "One goal from a better prize! Watch a short video and get 1 extra shot.",
    ad_offer_shoot: "One hit from a better prize! Watch a short video and get 1 extra shot.",
    ad_offer_basket: "Watch a short video and retry {level} with the clock reset!",
    c_missline: "The claw lost its grip… try again!",
    pop_grab: "GRAB!", pop_slip: "SLIPPED!",
    // lucky wheel
    tile_wheel: "Lucky Wheel",
    w_sign2: "PICK 3 OF 20 NUMBERS",
    w_lede: "Pick 3 numbers and spin the big wheel, if the pointer lands on one of yours, you win a medium plush! The numbers share their colours with the wheel.",
    w_pick: "Pick {n} more",
    w_ready: "Ready to spin!",
    w_spin: "SPIN THE WHEEL",
    w_spinning: "The wheel is spinning…",
    w_win: "LUCKY NUMBER!",
    w_winline: "The wheel landed on {n}, one of yours!",
    w_lose: "NOT THIS TIME",
    w_loseline: "The wheel landed on {n}. Pick numbers and try again!",
    w_prizenote1: "Prize: a medium plush",
    w_prizenote2: "3 out of 20, fortune favours the bold!",
    // Race Cars
    tile_race: "Race Cars",
    rc_sign2: "FIRST TO {laps} LAPS",
    rc_lede: "Bumper-car racing seen from above! Steer around the oval, grab boosts and feel free to shove the others, first to {laps} laps wins.",
    rc_rule1: "Steer with the corner joystick (or the arrow keys)",
    rc_rule2: "Drive over a boost pad for a proper push forward",
    rc_rule3: "Bumping is allowed, shove your rivals into the walls!",
    rc_prizenote: "Easy = small · Medium = medium · Hard = GOLD TROPHY",
    rc_start: "START THE RACE",
    rc_ready: "READY…",
    rc_go: "GO!",
    rc_track: "Track",
    rc_track_oval: "Oval", rc_track_heart: "Heart Track", rc_track_tri: "Triangle",
    rc_lap: "Lap {n}/{max}",
    rc_lapup: "LAP {n}/{max}",
    rc_pos: "No. {n}",
    rc_boost: "BOOST!",
    rc_win: "VICTORY!",
    rc_winline: "1st place, you won the race!",
    rc_finishpop: "FINISH!",
    rc_trophy_ribbon: "CHAMPION'S TROPHY!",
    rc_trophyline: "You won on Hard, the trophy is now in your prize room!",
    rc_fail: "CHECKERED FLAG",
    rc_failline: "You crossed the line in place no. {n}, back behind the wheel!",
    tile_hang: "Hangtime",
    ht_sign2: "KEEP YOUR BALANCE",
    ht_lede: "The tightrope walker crosses the slack line high above the ring. Keep the needle in the green zone, lean too far and he drops into the net! The wind makes it harder and harder.",
    ht_rule1: "Keep the needle inside the green zone on the gauge",
    ht_rule2: "Watch the wind gusts, they come from both sides",
    ht_rule3_mouse: "Move the mouse sideways to lean him, or use the arrow keys",
    ht_rule3_touch: "Tilt your phone to lean, or hold the sides of the screen",
    ht_prizenote: "{lille}s=small · {mellem}s=medium · {stor}s=large · {pokal}s=GOLD TROPHY",
    ht_start_mouse: "ON THE WIRE",
    ht_start_gyro: "PLAY WITH TILT",
    ht_start_touch: "Play with side taps",
    ht_mode_gyro: "TILT",
    ht_mode_mouse: "MOUSE",
    ht_mode_touch: "TAP",
    ht_gyro_denied: "Couldn't access the phone's tilt, use tap controls instead.",
    ht_crossings: "Crossings: {n}",
    ht_cross: "CROSSING {n}!",
    ht_win: "WHAT BALANCE!",
    ht_winline: "You stayed up for {s} seconds!",
    ht_trophy_ribbon: "TIGHTROPE LEGEND!",
    ht_trophyline: "{s} seconds on the wire, the trophy is now in your prize room!",
    ht_fail: "INTO THE NET",
    ht_failline: "{s} seconds, you need {need} for a prize. Back on the wire!",
    tile_cans: "Can Knockdown",
    cn_sign2: "{shots} THROWS",
    cn_lede: "Ten tin cans in a pyramid, knock the WHOLE tower off the table in at most {shots} throws! Fewer throws, better prize.",
    cn_rule1: "Pull DOWN and release to sling the ball at the tower",
    cn_rule2: "Cans only count once they're completely off the table",
    cn_rule3: "Full power isn't always best, aim for the base!",
    cn_prizenote: "2 throws = GOLD TROPHY · 3 = large · 4 = medium · 5 = small",
    cn_start: "THROW AWAY",
    cn_cans: "Cans left: {n}",
    cn_shots: "Throw {n}/{max}",
    cn_out: "OUT!",
    cn_win: "TOWER DOWN!",
    cn_winline: "All 10 cans went down in {n} throws!",
    cn_trophy_ribbon: "KING OF CANS!",
    cn_trophyline: "The whole tower in just {n} throws, the trophy is yours!",
    cn_fail: "THE TOWER STANDS",
    cn_failline: "{n} cans survived, new tower, new chances!",
    tile_mole: "Whack-a-Mole",
    mo_sign2: "{s} SECONDS",
    mo_lede: "The moles are swarming out of their holes, whack them before they duck back down! You have {s} seconds, and it gets faster and faster.",
    mo_rule1: "Tap the moles while they're up",
    mo_rule2: "Golden moles are worth 3 points",
    mo_rule3: "The pace picks up, keep cool at the end",
    mo_prizenote: "{lille}=small · {mellem}=medium · {stor}=large · {pokal}=GOLD TROPHY",
    mo_start: "START WHACKING",
    mo_hits: "Whacked: {n}",
    mo_win: "WHAT A HUNT!",
    mo_winline: "You whacked {n} moles!",
    mo_trophy_ribbon: "MOLE MASTER!",
    mo_trophyline: "{n} moles before the whistle, the trophy is now in your prize room!",
    mo_fail: "THEY GOT AWAY",
    mo_failline: "You whacked {n}, you need at least {need} for a prize. Try again!",
    names_horse: ["Stormwind", "Sugarsnout", "Baron von Trot", "Miss Swift", "Goldhoof", "Prince Snort", "Madam Mule", "Lightning Lily", "Sir Gallops", "Oat Otis"],
    names_race: ["Turbo Ted", "Gears Gus", "Nitro Nan", "Oily Owen", "Skid Sid", "Brake Bea", "Vroom Vic", "Fuel Fred", "Drift Dot", "Zoom Zara"],
    pop_goal: "GOAL!", pop_saved: "SAVED!", pop_post: "POST!", pop_over: "CROSSBAR!",
    pop_basket: "BASKET!", pop_hit: "HIT!",
  },
  de: {
    menu_welcome: "WILLKOMMEN AN DER BUDE",
    menu_allwin: "JEDER KANN GEWINNEN",
    play: "SPIELEN",
    tile_horse: "Pferderennen",
    tile_football: "Fußball",
    tile_basket: "Basketball",
    tile_shoot: "Schießbude",
    tile_prizes: "Preiskammer",
    tile_board: "Bestenliste",
    prizes_one: "PREIS",
    prizes_many: "PREISE",
    board_go: "BESTENLISTE",
    footer_privacy: "Datenschutz",
    name_q: "Wie heißt du?",
    name_note: "Dein Name erscheint auf der Bestenliste und an der Rennbahn. Nimm am besten einen Spitznamen, alle Spieler können ihn sehen.",
    name_ph: "Dein Name",
    name_save: "SPEICHERN",
    name_err_len: "Der Name muss 2-12 Zeichen lang sein.",
    name_err_rude: "Das können wir nicht auf den Pokal gravieren… versuch einen anderen.",
    back: "‹ Menü",
    sign_free: "GRATIS",
    play_again: "Nochmal spielen",
    try_again: "Nochmal versuchen",
    to_menu: "Zum Menü",
    your_prize: "Dein Preis:",
    in_room: "– er steht jetzt in deiner Preiskammer!",
    you: "Du",
    ld_h1: "Teddy Chase – klassische Jahrmarktbuden und lustige Spiele online",
    ld_intro: "Teddy Chase ist eine kostenlose Sammlung von fünfzehn klassischen Jahrmarktbuden, die du direkt im Browser spielst, auf Handy, Tablet und PC, ohne Download und ohne Käufe. Gewinne Kuscheltiere in fröhlichen Farben und glänzende Goldpokale, fülle dein Preiszimmer und kämpfe um die Plätze auf der globalen Bestenliste. Das Spiel gibt es in sechs Sprachen: Dänisch, Englisch, Deutsch, Italienisch, Französisch und Spanisch.",
    ld_g_horse: "Der König der Buden: roll Kugeln die Rampe hinauf und triff die Löcher, jeder Punkt bringt dein Pferd Richtung Ziel. Drei Bahnen, Blocker-Stifte und bis zu fünf Gegner.",
    ld_g_claw: "Der klassische Greifautomat online: tippe im richtigen Moment und angle genau das Kuscheltier, das du im Haufen siehst. Drei Versuche pro Viertelstunde, also nutze sie gut.",
    ld_g_shoot: "Schießbude wie auf dem echten Jahrmarkt: drei Reihen Monster in Bewegung, triff 7 für einen Preis, triff alle 10 und hol den Goldpokal.",
    ld_g_wheel: "Wähle 3 der 20 Zahlen des Rads und dreh. Landet der Zeiger auf deiner Zahl, gehört das mittelgroße Kuscheltier dir.",
    ld_g_race: "Funkauto-Rennen von oben mit Joystick, Boosts und Ellbogen, drei Strecken, fünf Runden, und ein Goldpokal für den Sieg auf Schwer.",
    ld_g_football: "Acht Schüsse gegen einen Torwart, der täuscht und schneller wird. Schlenz den Ball an ihm vorbei, acht Tore in Folge bringen den Pokal, mit Hattrick-Jubel unterwegs.",
    ld_g_basket: "Drei Level gegen die Uhr mit einem Korb, der immer schneller gleitet. Schaff das Finale und such dir dein Kuscheltier aus.",
    ld_g_mole: "60 Sekunden, neun Löcher und Maulwürfe in immer höherem Tempo, die goldenen zählen drei Punkte, und die Gucker sind fast nicht zu erwischen.",
    ld_g_cans: "Dosenwerfen mit echter Physik: wirf die ganze Pyramide in fünf Würfen vom Tisch. Schaffst du es in zwei, wartet der Goldpokal.",
    ld_g_hang: "Halte den Seiltänzer im Wind in Balance, mit Maus, Pfeiltasten oder durch Kippen des Handys. Je länger du durchhältst, desto größer der Preis.",
    ld_g_punch: "Vier Schritte, je ein Tipp: perfekt zurückgehen, Schwung holen, die Power treffen und in den Sandsack fliegen. Bis zu 1.000 Punkte, und du kannst die Herausforderung an Freunde schicken.",
    ld_g_exchange: "Werden die Regale voll? Tausche 100 Kuscheltiere gegen eine Goldmünze mit dem Logo-Teddy. Die Münze zählt als 100 Preise, dein Platz auf der Bestenliste bleibt gleich.",
    ld_faq_h: "Häufige Fragen",
    ld_q1: "Sind die Spiele kostenlos?",
    ld_a1: "Ja, alle fünfzehn Buden sind komplett kostenlos, und es gibt keine Käufe im Spiel.",
    ld_q2: "Kann ich auf dem Handy spielen?",
    ld_a2: "Ja, die Spiele sind fürs Handy gebaut: Touch-Steuerung, Joystick und Gyro, und sie laufen genauso gut auf Tablet und PC.",
    ld_q3: "In welchen Sprachen gibt es das Spiel?",
    ld_a3: "Dänisch, Englisch, Deutsch, Italienisch, Französisch und Spanisch. Die Sprache wird automatisch nach deinem Browser gewählt und lässt sich jederzeit mit dem Flaggen-Knopf ändern.",
    ld_q4: "Was kann man gewinnen?",
    ld_a4: "Kuscheltiere in drei Größen und Goldpokale, gesammelt in deinem Preiszimmer, und deine Gewinne zählen auf der globalen Bestenliste.",
    tile_punch: "Sandsack", tile_exchange: "Teddybörse", ex_go: "ZUR BÖRSE",
    ex_coin_one: "Goldmünze", ex_coin_many: "Goldmünzen",
    ex_lede: "Tausche {n} Kuscheltiere gegen 1 Goldmünze mit dem Logo-Teddy. Die Münze zählt als {n} Preise auf der Tafel, dein Gesamtstand bleibt gleich. Dafür bekommen die Regale Luft!",
    ex_missing: "Sammle noch {n} Kuscheltiere, dann kannst du tauschen.",
    ex_ready: "Du hast genug. Bereit zum Tauschen!",
    ex_cta: "{n} Kuscheltiere gegen 1 Goldmünze tauschen",
    ex_note: "Pokale bleiben unberührt. 1 Goldmünze = {n} Preise auf der Bestenliste.",
    ex_confirm_t: "Bist du sicher?",
    ex_confirm: "Du gibst {n} Kuscheltiere ab (kleinste und älteste zuerst) und bekommst 1 Goldmünze ins Preiszimmer.",
    ex_yes: "Jetzt tauschen", ex_no: "Abbrechen",
    ex_done_t: "Glückwunsch!", ex_done: "Du hast eine Goldmünze! Sie steht jetzt ganz oben im Preiszimmer.",
    ex_more: "Nochmal tauschen",
    pb_sign2: "0-1.000 PUNKTE",
    pb_lede: "Vier Schritte, je ein Tipp: perfekt zurückgehen, Schwung holen, die Power treffen und genau ins Ziel. Bis zu 1.000 Punkte, nur dein eigener Rekord zählt.",
    pb_rule1: "1. Zurückgehen und auf der Marke stoppen (200 Punkte)",
    pb_rule2: "2. Mit dem Arm Schwung holen (200 Punkte)",
    pb_rule3: "3. Die Power am Höhepunkt stoppen (300 Punkte)",
    pb_rule4: "4. Den Sack genau in der Mitte treffen (300 Punkte)",
    pb_prizenote: "Keine Preise, nur Ruhm: schlag deinen Rekord und fordere Freunde heraus.",
    pb_best: "Rekord: {n}", pb_start: "DING DING!",
    pb_hint_walk: "Tippe, wenn der Teddy auf der Marke steht!",
    pb_hint_windup: "Tippe am höchsten Punkt des Schwungs!",
    pb_hint_power: "Tippe, wenn die Power im goldenen Feld ist!",
    pb_hint_aim: "Tippe, wenn das Visier mitten auf dem Sack steht!",
    pb_ph_walk: "Abstand", pb_ph_windup: "Schwung", pb_ph_power: "Power", pb_ph_aim: "Ziel",
    pb_res_great: "VOLLTREFFER!", pb_res_ok: "Guter Schlag!", pb_res_low: "Nochmal aufwärmen",
    pb_res_ko: "DER SACK IST EXPLODIERT!",
    pb_hs_btn: "Highscores",
    pb_hs_month: "Dieser Monat",
    pb_hs_all: "Allzeit",
    pb_hs_empty: "Noch keine Scores",
    pb_hs_err: "Liste konnte nicht geladen werden",
    pb_hs_close: "Schließen",
    tile_duck: "Ententeich",
    dp_sign2: "ANGLE 10 ENTEN",
    dp_lede: "Tauche den Magneten in den Teich und angle 10 Enten. Das Zeichen auf der Unterseite entscheidet den Preis, und 3 gleiche Zeichen gewinnen einen Teddy!",
    dp_rule1: "Grünes Zeichen: 3 gleiche = kleiner Teddy",
    dp_rule2: "Blaues Zeichen: 3 gleiche = mittlerer Teddy. Goldmünze: 3 gleiche = GROSSER Teddy",
    dp_rule3: "Joker: gewinnt nichts, mehr Glück bei der nächsten Ente",
    dp_start: "ANGELN!",
    dp_hint: "Ziele mit dem Magneten und tippe zum Angeln",
    dp_fished: "Geangelt: {n}/{m}",
    dp_joker: "JOKER",
    dp_found_gron: "GRÜNES ZEICHEN",
    dp_found_blaa: "BLAUES ZEICHEN",
    dp_found_guld: "GOLDMÜNZE",
    dp_res_win1: "DU HAST EINEN TEDDY GEWONNEN!",
    dp_res_win: "DU HAST {n} TEDDYS GEWONNEN!",
    dp_res_none: "DIESMAL KEINE TEDDYS",
    dp_claim: "WÄHLE DEINE TEDDYS",
    tile_pusher: "Münzschieber",
    pu_sign2: "100 SILBERMÜNZEN",
    pu_lede: "Du bekommst 100 Silbermünzen. Time deine Würfe, schiebe die Münzen über zwei Kanten und sieh, wie viele Goldmünzen du aus der Maschine drückst.",
    pu_rule1: "Tippe, um eine Münze aus dem wandernden Schlitz zu lösen",
    pu_rule2: "Silbermünzen in der Schale wandern zurück in deinen Vorrat",
    pu_rule3: "Gold zählt für den Highscore. Münzen in den Seitenrinnen sind verloren",
    pu_start: "SPIELEN!",
    pu_hint: "Löse die Münze, während der Schieber zurückgezogen ist",
    pu_last: "Die letzten Münzen rollen...",
    pu_silver: "Silber",
    pu_gold: "Gold",
    pu_res_title: "{n} GOLDMÜNZEN!",
    pu_res_title1: "1 GOLDMÜNZE!",
    pu_goldrain: "GOLDREGEN!",
    tile_hammer: "Hau den Lukas",
    hm_sign2: "LÄUTE DIE GLOCKE",
    hm_lede: "Drei Schritte mit je einem Tipp: Hammer heben, Kraft aufladen und die Platte genau treffen. Triffst du das Grün, fliegt der Puck zur Glocke!",
    hm_rule1: "Heben (300) und Kraft (300): stoppe den Zeiger im GRÜNEN Feld",
    hm_rule2: "Zielen (400): je näher an der Mittellinie, desto höher fliegt der Puck",
    hm_rule3: "Über 900 Punkte: die Glocke läutet und du wählst einen GROSSEN Teddy",
    hm_start: "SCHWING DEN HAMMER!",
    hm_prizenote: "Nur ein Preis: der GROSSE Teddy über 900 Punkte. Jeder Score zählt für den Highscore.",
    hm_ph_pull: "Heben",
    hm_ph_power: "Kraft",
    hm_ph_aim: "Zielen",
    hm_hint_pull: "Tippe, wenn der Zeiger im Grünen steht",
    hm_hint_power: "Tippe im grünen Feld, das ist am besten",
    hm_hint_aim: "Triff so nah an der Mitte wie möglich",
    hm_bell: "DIE GLOCKE LÄUTET!",
    hm_res_great: "RIESENSCHLAG!",
    hm_res_ok: "GUTER SCHWUNG!",
    hm_res_low: "DER PUCK WAR SCHÜCHTERN",
    hm_best: "Rekord: {n}",
    tile_bump: "Autoscooter",
    bp_sign2: "SCHUBS SIE RAUS",
    bp_lede: "Autoscooter-Sumo: schubse die anderen über den Rand der Arena. Überlebe in der Vorrunde unter den letzten 3 und schlage die harten Bots im Finale.",
    bp_rule1: "Lenke mit Joystick, Seiten-Tipps oder Pfeiltasten, das Auto gibt selbst Gas",
    bp_rule2: "Vorrunde: 6 Autos, die letzten 3 kommen ins Finale",
    bp_rule3: "Finale: der Sieger holt den GOLDPOKAL, Platz 2 und 3 einen mittleren Teddy",
    bp_start: "AUF IN DEN KAMPF!",
    bp_round1: "VORRUNDE",
    bp_final: "DAS FINALE",
    bp_go: "LOS!",
    bp_left: "{n} Autos übrig",
    bp_out: "{name} ist raus!",
    bp_you_out: "DU BIST RAUSGEFLOGEN!",
    bp_qualified: "WEITER INS FINALE!",
    bp_res_win: "FINALSIEGER!",
    bp_res_win_sub: "Du hast alle rausgeschubst und gewinnst den Goldpokal!",
    bp_res_second: "SO NAH AM TITEL!",
    bp_res_out: "IN DER VORRUNDE AUSGESCHIEDEN",
    ld_g_hammer: "Klassischer Hau den Lukas: drei Tipps steuern Heben, Kraft und Zielen auf einer rot-orange-grünen Leiste. Triff immer das Grün, dann läutet die Glocke und der große Teddy gehört dir.",
    ld_g_bump: "Autoscooter-Sumo: schubse Bots über den Rand der runden Arena, zwei Runden lang. Überlebe die Vorrunde, gewinne das Finale gegen die harten Bots und hol den Goldpokal.",
    pu_res_note: "Das Silber ist verbraucht und die Maschine steht still. Dein Gold zählt für den Highscore.",
    ld_g_duck: "Magnetangeln in einem lebendigen Ententeich: angle 10 Enten und dreh sie um. Drei gleiche Zeichen auf der Unterseite gewinnen einen Teddy, drei Goldmünzen einen GROSSEN Teddy.",
    ld_g_pusher: "Klassischer Münzschieber mit zwei Ebenen: 100 Silbermünzen, pendelnde Schieber und Goldmünzen an der Kante. Silber in der Schale darf erneut fallen, Gold zählt für den Highscore.",
    pb_challenge: "Freunde herausfordern", pb_copied: "Link kopiert!",
    pb_share_text: "Ich habe {n} Punkte am Sandsack in Teddy Chase geholt. Schlag das!",
    hm_share_text: "Ich habe {n} Punkte bei Hau den Lukas in Teddy Chase geholt. Schlag das!",
    pb_ch_banner: "{name} fordert dich heraus: {n} Punkte. Schlag das!",
    pb_ch_beat: "Du hast {name} geschlagen!", pb_ch_lost: "{name} führt noch mit {n} Punkten.",
    size_lille: "Klein", size_mellem: "Mittelgroß", size_stor: "Groß",
    color_neonpink: "Rosa", color_giftgroen: "Hellgrün", color_elblaa: "Himmelblau",
    color_neonorange: "Orange", color_skriggul: "Sonnengelb", color_neonlilla: "Lavendel",
    color_turkis: "Mint", color_knaldroed: "Korallenrot",
    type_bamse: "Teddy", type_enhjoerning: "Einhorn", type_dino: "Dino",
    type_blaeksprutte: "Krake", type_froe: "Frosch", type_kanin: "Hase",
    type_panda: "Panda", type_loeve: "Löwe", type_elefant: "Elefant",
    type_pingvin: "Pinguin", type_haj: "Hai", type_koala: "Koala",
    type_hund: "Stoffhund", type_giraf: "Giraffe", type_bjoern: "Bär",
    trophy: "Goldpokal",
    pp_ribbon: "PREIS!",
    pp_won: "Du hast ein Kuscheltier gewonnen ({size}), such dir eins aus:",
    pr_title: "PREISKAMMER",
    pr_count_one: "Preis", pr_count_many: "Preise",
    pr_tip: "Halte ein Kuscheltier gedrückt und zieh es umher",
    pr_empty: "Die Regale sind leer…",
    pr_empty2: "Gewinn dein erstes Kuscheltier!",
    lb_title: "BESTENLISTE",
    lb_name: "Name", lb_trophies: "Pokale", lb_plush: "Kuscheltiere", lb_total: "Gesamt",
    lb_empty: "Noch niemand auf der Liste, los, gewinnen!",
    lb_note: "Global",
    lb_loading: "Lade den Stand…",
    lb_offline: "Die globale Bestenliste konnte nicht geladen werden, prüf deine Verbindung.",
    name_device_note: "Dieses Gerät hat einen Platz auf der globalen Bestenliste, ein neuer Name übernimmt diesen Platz.",
    h_sign2: "2 KUGELN AUF EINMAL",
    h_lede: "Nimm die Kugeln aus der Schale und leg sie an die Startlinie, die Position bestimmt deinen Winkel! Roll sie die Rampe hinauf und flieg über die Kante: Jedes Loch bringt dein Pferd voran. Wer zuerst {goal} erreicht, gewinnt das Rennen und einen Preis!",
    h_opponents: "Gegner",
    h_difficulty: "Schwierigkeit",
    diff_let: "Leicht", diff_mellem: "Mittel", diff_svaer: "Schwer",
    h_track_let: "Bahn: Die Klassische, offenes Brett und freie Bahn zur roten 3",
    h_track_mellem: "Bahn: Doppel-Gold. ZWEI rote 3er hinten in den Ecken, jede von einem Stift bewacht",
    h_track_svaer: "Bahn: Der Wächter, drei Stifte versperren den direkten Schuss auf Rot (drüberfliegen oder außen rum!)",
    h_prizenote: "Preise: Leicht = klein · Mittel = klein & mittel · Schwer = alle, und je mehr Gegner, desto größer die Chance auf die GROSSEN!",
    h_start: "Rennen starten",
    h_legend_red: "Rot = 3", h_legend_blue: "Blau = 2", h_legend_yellow: "Gelb = 1",
    h_yourhorse: "Dein Pferd:",
    h_last: "Letzte Kugel: +{pts}",
    h_win: "DU HAST GEWONNEN!", h_lose: "DAS RENNEN IST VORBEI",
    h_wonrace: "hat das Rennen gewonnen!",
    h_noprize: "Diesmal kein Preis, versuch's nochmal!",
    h_points: "Punkte",
    h_hint_take: "Nimm eine Kugel aus der Schale und leg sie zwischen die Linien",
    h_hint_move: "Beweg die Kugel frei, zieh nach hinten zum Schießen!",
    f_sign2: "{shots} SCHÜSSE, {need} TORE = PREIS",
    f_lede: "Du hast {shots} Schüsse gegen den Torwart, er rutscht hin und her, erreicht aber die Ecken nicht. Zieh in einem Bogen, um den Ball um ihn herumzuschrauben!",
    f_rule1: "{shots} Schüsse, mindestens {need} Tore bringen einen Preis",
    f_rule2: "Der Torwart bewegt sich, täuscht nach 2 Toren, wird schneller nach 3, und beim letzten Schuss gibt er ALLES!",
    f_rule3: "Effet: Zieh den Finger in einem Bogen, dann dreht der Schuss",
    f_rule4: "Volle Kraft (roter Balken) = Lattenrisiko!",
    f_prizenote: "Preis nach Toren: 3-4 = klein · 5 = mittel · 6-7 = GROSS · alle 8 = GOLDPOKAL!",
    f_start: "Anpfiff",
    f_goals: "Tore:", f_shots: "Schuss {n} / {max}",
    f_win: "WAS FÜR EIN FUSS!", f_fail: "DER TORWART HAT GEWONNEN!",
    f_winline: "{goals} Tore bei {shots} Schüssen!",
    f_failline: "{goals} Tore bei {shots} Schüssen, {need} waren nötig. Nochmal!",
    f_trophy_ribbon: "GOLDPOKAL!",
    f_trophyline: "Alle {shots} Tore! Der Goldpokal steht jetzt im obersten Regal deiner Preiskammer!",
    f_hint: "Nimm einen Ball, zieh im Bogen für Effet!",
    f_banner: "{shots} SCHÜSSE. MINDESTENS {need} TORE!",
    f_hattrick: "HATTRICK!",
    f_hattrick2: "DOPPELTER HATTRICK!",
    f_hattrick_sub: "{n} TORE • {n} SCHÜSSE",
    f_curve: "EFFET",
    tray_empty: "LEER",
    b_sign2: "3 LEVEL GEGEN DIE UHR",
    b_lede: "Die Zeit ist dein Gegner! Du hast 30 Sekunden pro Level: Triff den Korb {n1}-, dann {n2}- und im Finale {n3}-mal. Der Korb bewegt sich in Level 2 und im Finale!",
    b_rule1: "Level 1, triff {n} in 30 Sek. (der Korb steht still)",
    b_rule2: "Level 2, triff {n} in 30 Sek. (der Korb gleitet)",
    b_rule3: "Finale, triff {n} in 30 Sek. (schneller Korb, und du bekommst einen Extra-Ball!)",
    b_prizenote: "Preis: Schaff alle drei Level und gewinn ein mittelgroßes Kuscheltier, hier immer.",
    b_start: "Uhr starten",
    b_level: "Level", b_final: "Das Finale",
    b_of: "Level {n} von {max}",
    b_win: "DU HAST DIE UHR BESIEGT!",
    b_winline: "Alle {n} Level geschafft!",
    b_fail: "ZEIT ABGELAUFEN!",
    b_failline: "Du kamst bis {level}, diesmal kein Preis.",
    b_hint: "Nimm einen Ball aus der Schale und leg ihn zwischen die Linien",
    b_banner1: "TRIFF {n} IN 30 SEK!",
    b_banner2: "{level}. TRIFF {n} IN 30 SEK!",
    b_banner3: "FINALE. TRIFF {n} · EXTRA-BALL!",
    s_sign2: "{shots} SCHÜSSE. TRIFF DIE MONSTER",
    s_lede: "Die Monster ziehen in drei Reihen vorbei, je weiter weg, desto schneller! Du hast {shots} Schüsse. Triff so viele du kannst!",
    s_rule1: "{shots} Schüsse, triff 7 Monster für einen kleinen Teddy",
    s_rule2: "8 Treffer = mittelgroßer Teddy · 9 = GROSSER Teddy",
    s_rule3: "Die Kürbisse hinten tauchen wieder auf, der Rest bleibt unten!",
    s_rule4: "Alle 10 = GOLDPOKAL!",
    s_trophy_ribbon: "GOLDPOKAL!",
    s_trophyline: "Alle {shots} Monster getroffen! Der Goldpokal steht jetzt im obersten Regal deiner Preiskammer!",
    s_prizenote: "Die Kugel trifft das erste Monster auf ihrem Weg, ziel auf die schnellen Reihen, wenn du dich traust!",
    s_start: "Fertig, zielen, Feuer",
    s_hits: "Treffer:", s_shots: "Schuss {n} / {max}",
    s_win: "WAS FÜR EIN AUGE!",
    s_fail: "DIE MONSTER SIND ENTKOMMEN!",
    s_winline: "{hits} von {shots} Monstern getroffen!",
    s_failline: "Nur {hits} getroffen, 7 waren nötig. Nochmal!",
    s_hint: "Nimm eine Kugel und schieß auf die Monster!",
    s_banner: "TRIFF DIE MONSTER!",
    tile_claw: "Greifautomat",
    c_sign2: "3 VERSUCHE PRO 15 MIN",
    c_lede: "Der Greifer fährt über den Haufen hin und her, tipp, wenn er über deinem Wunsch-Kuscheltier ist, und drück die Daumen für einen guten Griff!",
    c_rule1: "Tipp, um den Greifer fallen zu lassen",
    c_rule2: "Triffst du sauber, kommt das Kuscheltier mit hoch",
    c_rule3: "3 Versuche pro Viertelstunde, damit der Automat nicht leergeräumt wird",
    c_prizenote: "Gewinn: das kleine Kuscheltier, das du angelst, genau wie du es siehst!",
    c_start: "Automat starten",
    c_tries: "Versuche: {n} / 3",
    c_wait: "Nächster Versuch in {t}",
    c_hint: "Tipp, um den Greifer fallen zu lassen!",
    c_locked: "Der Automat ruht sich aus, komm in {t} wieder",
    c_win: "WAS FÜR EIN GRIFF!",
    c_missline: "Der Greifer hat losgelassen… nochmal!",
    c_done_won: "Du hast {n} Kuscheltiere geangelt, sie stehen jetzt in deiner Preiskammer!",
    c_done_won1: "Du hast 1 Kuscheltier geangelt, es steht jetzt in deiner Preiskammer!",
    c_done_zero_title: "LEERER GRIFF!",
    c_done_zero: "Der Greifer hat diesmal nichts erwischt, mehr Glück beim nächsten Mal!",
    ad_offer_claw: "Der Greifer lädt auf… oder schau ein kurzes Video und bekomm sofort 6 neue Versuche!",
    ad_watch: "Video ansehen",
    ad_no: "Nein danke",
    ad_fail: "Das Video konnte nicht gezeigt werden, versuch es später nochmal.",
    ad_bonus: "+{n} Bonusversuche",
    ad_label: "Anzeige",
    doc_title: "Teddy Chase – kostenlose Spiele: Pferderennen, Greifautomat u.v.m.",
    ad_offer_double: "Doppelt oder nichts! Schau ein kurzes Video und mach deinen Preis {size}.",
    ad_upgraded: "Preis aufgewertet, such dir dein Kuscheltier aus!",
    ad_offer_cans_title: "SO KNAPP!",
    ad_offer_cans: "Noch {n} Dosen, schau ein kurzes Video und bekomm 1 Extra-Ball!",
    ad_offer_football: "Ein Tor von einem besseren Preis entfernt! Schau ein kurzes Video und bekomm 1 Extra-Schuss.",
    ad_offer_shoot: "Ein Treffer von einem besseren Preis entfernt! Schau ein kurzes Video und bekomm 1 Extra-Schuss.",
    ad_offer_basket: "Schau ein kurzes Video und versuch {level} noch einmal mit frischer Uhr!",
    pop_grab: "GRIFF!", pop_slip: "WEG!",
    tile_wheel: "Glücksrad",
    w_sign2: "TIPPE 3 VON 20 ZAHLEN",
    w_lede: "Wähl 3 Zahlen und dreh das große Rad, landet der Zeiger auf einer deiner Zahlen, gewinnst du ein mittelgroßes Kuscheltier! Die Zahlen haben dieselbe Farbe wie ihr Feld auf dem Rad.",
    w_pick: "Noch {n} Zahlen wählen",
    w_ready: "Bereit zum Drehen!",
    w_spin: "RAD DREHEN",
    w_spinning: "Das Rad dreht sich…",
    w_win: "GLÜCKSZAHL!",
    w_winline: "Das Rad landete auf {n}, eine von deinen!",
    w_lose: "DIESMAL NICHT",
    w_loseline: "Das Rad landete auf {n}. Wähl Zahlen und versuch's nochmal!",
    w_prizenote1: "Gewinn: ein mittelgroßes Kuscheltier",
    w_prizenote2: "3 von 20, das Glück ist mit den Mutigen!",
    tile_race: "Rennautos",
    rc_sign2: "WER ZUERST {laps} RUNDEN HAT",
    rc_lede: "Autoscooter-Rennen von oben! Steuer dein Auto über die Bahn, sammel Boosts und schubs ruhig die anderen, wer zuerst {laps} Runden schafft, gewinnt.",
    rc_rule1: "Steuer mit dem Joystick in der Ecke (oder den Pfeiltasten)",
    rc_rule2: "Fahr über ein Boost-Feld für einen ordentlichen Schub",
    rc_rule3: "Rempeln ist erlaubt, schieb die Rivalen in die Bande!",
    rc_prizenote: "Leicht = klein · Mittel = mittelgroß · Schwer = GOLDPOKAL",
    rc_start: "RENNEN STARTEN",
    rc_ready: "BEREIT…",
    rc_go: "LOS!",
    rc_track: "Strecke",
    rc_track_oval: "Oval", rc_track_heart: "Herzbahn", rc_track_tri: "Dreieck",
    rc_lap: "Runde {n}/{max}",
    rc_lapup: "RUNDE {n}/{max}",
    rc_pos: "Platz {n}",
    rc_boost: "BOOST!",
    rc_win: "SIEG!",
    rc_winline: "1. Platz, du hast das Rennen gewonnen!",
    rc_finishpop: "ZIEL!",
    rc_trophy_ribbon: "MEISTERPOKAL!",
    rc_trophyline: "Du hast auf Schwer gewonnen, der Pokal steht jetzt in deiner Preiskammer!",
    rc_fail: "ZIELFLAGGE",
    rc_failline: "Du kamst als Nr. {n} ins Ziel, zurück ans Steuer!",
    tile_hang: "Hangtime",
    ht_sign2: "HALTE DIE BALANCE",
    ht_lede: "Der Seiltänzer läuft übers Seil, hoch über der Manege. Halt den Zeiger im grünen Feld, kippt er zu weit, fällt er ins Netz! Der Wind macht es immer schwerer.",
    ht_rule1: "Halt den Zeiger im grünen Feld der Anzeige",
    ht_rule2: "Achtung Windböen, sie kommen von beiden Seiten",
    ht_rule3_mouse: "Beweg die Maus zur Seite, um ihn zu lehnen, oder nimm die Pfeiltasten",
    ht_rule3_touch: "Kipp das Handy zum Lehnen, oder halt die Seiten des Bildschirms",
    ht_prizenote: "{lille}s=klein · {mellem}s=mittel · {stor}s=groß · {pokal}s=GOLDPOKAL",
    ht_start_mouse: "AUFS SEIL",
    ht_start_gyro: "MIT KIPPEN SPIELEN",
    ht_start_touch: "Mit Seiten-Tippen spielen",
    ht_mode_gyro: "KIPPEN",
    ht_mode_mouse: "MAUS",
    ht_mode_touch: "TIPPEN",
    ht_gyro_denied: "Kein Zugriff auf den Neigungssensor, nimm die Tipp-Steuerung.",
    ht_crossings: "Überquerungen: {n}",
    ht_cross: "RUNDE {n}!",
    ht_win: "WAS FÜR EINE BALANCE!",
    ht_winline: "Du hast dich {s} Sekunden oben gehalten!",
    ht_trophy_ribbon: "SEILTÄNZER-LEGENDE!",
    ht_trophyline: "{s} Sekunden auf dem Seil, der Pokal steht jetzt in deiner Preiskammer!",
    ht_fail: "INS NETZ",
    ht_failline: "{s} Sekunden, du brauchst {need} für einen Preis. Zurück aufs Seil!",
    tile_cans: "Dosenwerfen",
    cn_sign2: "{shots} WÜRFE",
    cn_lede: "Zehn Blechdosen in einer Pyramide, wirf den GANZEN Turm in höchstens {shots} Würfen vom Tisch! Je weniger Würfe, desto besser der Preis.",
    cn_rule1: "Zieh nach UNTEN und lass los, um den Ball zu schleudern",
    cn_rule2: "Dosen zählen erst, wenn sie GANZ vom Tisch sind",
    cn_rule3: "Volle Kraft ist nicht immer am besten, ziel auf die Basis!",
    cn_prizenote: "2 Würfe = GOLDPOKAL · 3 = groß · 4 = mittel · 5 = klein",
    cn_start: "WIRF LOS",
    cn_cans: "Dosen übrig: {n}",
    cn_shots: "Wurf {n}/{max}",
    cn_out: "RAUS!",
    cn_win: "DER TURM IST GEFALLEN!",
    cn_winline: "Alle 10 Dosen in {n} Würfen runter!",
    cn_trophy_ribbon: "DOSEN-KÖNIG!",
    cn_trophyline: "Der ganze Turm in nur {n} Würfen, der Pokal gehört dir!",
    cn_fail: "DER TURM STEHT",
    cn_failline: "{n} Dosen haben überlebt, neuer Turm, neue Chancen!",
    tile_mole: "Hau den Maulwurf",
    mo_sign2: "{s} SEKUNDEN",
    mo_lede: "Die Maulwürfe wuseln aus den Löchern, hau sie, bevor sie wieder abtauchen! Du hast {s} Sekunden, und es wird immer schneller.",
    mo_rule1: "Tipp auf die Maulwürfe, solange sie oben sind",
    mo_rule2: "Goldene Maulwürfe bringen 3 Punkte",
    mo_rule3: "Das Tempo steigt, bleib am Ende cool",
    mo_prizenote: "{lille}=klein · {mellem}=mittel · {stor}=groß · {pokal}=GOLDPOKAL",
    mo_start: "JAGD STARTEN",
    mo_hits: "Getroffen: {n}",
    mo_win: "WAS FÜR EINE JAGD!",
    mo_winline: "Du hast {n} Maulwürfe erwischt!",
    mo_trophy_ribbon: "MAULWURF-MEISTER!",
    mo_trophyline: "{n} Maulwürfe in der Zeit, der Pokal steht jetzt in deiner Preiskammer!",
    mo_fail: "SIE SIND ENTWISCHT",
    mo_failline: "Du hast {n} erwischt, mindestens {need} sind nötig. Nochmal!",
    names_horse: ["Sturmwind", "Zuckermaul", "Baron Trab", "Blitz-Berta", "Goldhuf", "Prinz Prust", "Madam Mähne", "Hafer-Hugo", "Graf Galopp", "Frau Flink"],
    names_race: ["Gas-Gerd", "Turbo-Til", "Benzino", "Öl-Otto", "Nitro-Nia", "Brems-Bea", "Rad-Rudi", "Tank-Theo", "Zisch-Zoe", "Flitz-Fee"],
    pop_goal: "TOR!", pop_saved: "GEHALTEN!", pop_post: "PFOSTEN!", pop_over: "LATTE!",
    pop_basket: "KORB!", pop_hit: "TREFFER!",
  },
  it: {
    menu_welcome: "BENVENUTO AL LUNA PARK",
    menu_allwin: "TUTTI POSSONO VINCERE",
    play: "GIOCA",
    tile_horse: "Corsa dei cavalli",
    tile_football: "Calcio",
    tile_basket: "Basket",
    tile_shoot: "Tiro a segno",
    tile_prizes: "Sala premi",
    tile_board: "Classifica",
    prizes_one: "PREMIO",
    prizes_many: "PREMI",
    board_go: "CLASSIFICA",
    footer_privacy: "Privacy",
    name_q: "Come ti chiami?",
    name_note: "Il tuo nome appare in classifica e sulla pista. Meglio un soprannome, lo vedono tutti i giocatori.",
    name_ph: "Il tuo nome",
    name_save: "SALVA",
    name_err_len: "Il nome deve avere 2-12 caratteri.",
    name_err_rude: "Non possiamo incidere quello sulla coppa… provane un altro.",
    back: "‹ Menu",
    sign_free: "GRATIS",
    play_again: "Gioca ancora",
    try_again: "Riprova",
    to_menu: "Al menu",
    your_prize: "Il tuo premio:",
    in_room: "– ora è nella tua sala premi!",
    you: "Tu",
    ld_h1: "Teddy Chase – bancarelle classiche e giochi divertenti online",
    ld_intro: "Teddy Chase è una raccolta gratuita di quindici bancarelle classiche del luna park, da giocare direttamente nel browser, su cellulare, tablet e computer, senza download e senza acquisti. Vinci peluche dai colori allegri e trofei d'oro lucenti, riempi la tua sala premi e lotta per un posto nella classifica globale. Il gioco è disponibile in sei lingue: danese, inglese, tedesco, italiano, francese e spagnolo.",
    ld_g_horse: "Il re delle bancarelle: fai rotolare le palline su per la rampa e centra i fori, ogni punto porta il tuo cavallo verso il traguardo. Tre piste, birilli bloccanti e fino a cinque avversari.",
    ld_g_claw: "La classica pesca-peluche online: tocca al momento giusto e pesca esattamente il peluche che vedi nel mucchio. Tre tentativi ogni quarto d'ora, usali bene.",
    ld_g_shoot: "Un tiro a segno come al vero luna park: tre file di mostri in movimento, colpiscine 7 per un premio, tutti e 10 per il trofeo d'oro.",
    ld_g_wheel: "Scegli 3 dei 20 numeri della ruota e gira. Se la freccia si ferma sul tuo numero, il peluche medio è tuo.",
    ld_g_race: "Corse di macchinine radiocomandate viste dall'alto con joystick, boost e gomitate, tre piste, cinque giri, e trofeo d'oro per chi vince su Difficile.",
    ld_g_football: "Otto tiri contro un portiere che finta e accelera. Gira la palla oltre di lui, otto gol di fila valgono il trofeo, con festa da tripletta lungo il percorso.",
    ld_g_basket: "Tre livelli contro il tempo con un canestro che scivola sempre più veloce. Supera la finale e scegli il tuo peluche.",
    ld_g_mole: "60 secondi, nove buche e talpe sempre più rapide, quelle dorate valgono tre punti, e le curiose sono quasi impossibili da prendere.",
    ld_g_cans: "Tiro ai barattoli con fisica vera: butta giù l'intera piramide dal tavolo in cinque lanci. Se ci riesci in due, ti aspetta il trofeo d'oro.",
    ld_g_hang: "Tieni in equilibrio il funambolo nel vento, con mouse, frecce o inclinando il telefono. Più resisti, più grande è il premio.",
    ld_g_punch: "Quattro passi, un tocco ciascuno: indietreggia alla perfezione, carica, trova la potenza e vola contro il sacco. Fino a 1.000 punti, e puoi mandare la sfida a un amico.",
    ld_g_exchange: "Scaffali pieni? Scambia 100 peluche con una moneta d'oro con l'orsetto del logo. La moneta vale 100 premi, così il tuo posto in classifica non cambia.",
    ld_faq_h: "Domande frequenti",
    ld_q1: "I giochi sono gratuiti?",
    ld_a1: "Sì, tutte e quindici le bancarelle sono completamente gratuite, e non ci sono acquisti nel gioco.",
    ld_q2: "Posso giocare sul cellulare?",
    ld_a2: "Sì, i giochi sono fatti per il cellulare: controlli touch, joystick e giroscopio, e funzionano altrettanto bene su tablet e computer.",
    ld_q3: "In quali lingue è disponibile il gioco?",
    ld_a3: "Danese, inglese, tedesco, italiano, francese e spagnolo. La lingua viene scelta automaticamente dal browser e si può sempre cambiare con il pulsante della bandiera.",
    ld_q4: "Cosa si può vincere?",
    ld_a4: "Peluche in tre taglie e trofei d'oro, raccolti nella tua sala premi, e le tue vincite contano nella classifica globale.",
    tile_punch: "Colpisci il sacco", tile_exchange: "Borsa dei peluche", ex_go: "ALLA BORSA",
    ex_coin_one: "moneta d'oro", ex_coin_many: "monete d'oro",
    ex_lede: "Scambia {n} peluche con 1 moneta d'oro con l'orsetto del logo. La moneta vale {n} premi in classifica, il tuo totale non cambia. E gli scaffali respirano!",
    ex_missing: "Raccogli altri {n} peluche per poter scambiare.",
    ex_ready: "Ne hai abbastanza. Pronto a scambiare!",
    ex_cta: "Scambia {n} peluche con 1 moneta d'oro",
    ex_note: "I trofei non si toccano mai. 1 moneta d'oro = {n} premi in classifica.",
    ex_confirm_t: "Sei sicuro?",
    ex_confirm: "Consegni {n} peluche (prima i più piccoli e vecchi) e ricevi 1 moneta d'oro nella sala premi.",
    ex_yes: "Scambia ora", ex_no: "Annulla",
    ex_done_t: "Congratulazioni!", ex_done: "Hai una moneta d'oro! Ora è in cima alla sala premi.",
    ex_more: "Scambia ancora",
    pb_sign2: "0-1.000 PUNTI",
    pb_lede: "Quattro passi, un tocco ciascuno: indietreggia alla perfezione, carica il braccio, trova la potenza e colpisci al centro. Fino a 1.000 punti, conta solo il tuo record.",
    pb_rule1: "1. Indietreggia e fermati sul segno (200 punti)",
    pb_rule2: "2. Carica il braccio (200 punti)",
    pb_rule3: "3. Ferma la potenza al massimo (300 punti)",
    pb_rule4: "4. Colpisci il sacco al centro (300 punti)",
    pb_prizenote: "Niente premi qui, solo gloria: batti il record e sfida un amico.",
    pb_best: "Record: {n}", pb_start: "DING DING!",
    pb_hint_walk: "Tocca quando l'orsetto è sul segno!",
    pb_hint_windup: "Tocca in cima alla carica!",
    pb_hint_power: "Tocca quando la potenza è nel campo dorato!",
    pb_hint_aim: "Tocca quando il mirino è al centro del sacco!",
    pb_ph_walk: "Distanza", pb_ph_windup: "Carica", pb_ph_power: "Potenza", pb_ph_aim: "Mira",
    pb_res_great: "COLPO DA KO!", pb_res_ok: "Bel colpo!", pb_res_low: "Riscaldati ancora",
    pb_res_ko: "IL SACCO È ESPLOSO!",
    pb_hs_btn: "Classifica",
    pb_hs_month: "Questo mese",
    pb_hs_all: "Di sempre",
    pb_hs_empty: "Ancora nessun punteggio",
    pb_hs_err: "Impossibile caricare la lista",
    pb_hs_close: "Chiudi",
    tile_duck: "Lo stagno delle papere",
    dp_sign2: "PESCA 10 PAPERE",
    dp_lede: "Immergi il magnete nello stagno e pesca 10 papere. Il segno sul fondo decide il premio, e 3 segni uguali vincono un orsetto!",
    dp_rule1: "Segno verde: 3 uguali = orsetto piccolo",
    dp_rule2: "Segno blu: 3 uguali = orsetto medio. Moneta d'oro: 3 uguali = orsetto GRANDE",
    dp_rule3: "Jolly: non vince nulla, più fortuna con la prossima papera",
    dp_start: "A PESCA!",
    dp_hint: "Mira con il magnete e tocca per pescare",
    dp_fished: "Pescate: {n}/{m}",
    dp_joker: "JOLLY",
    dp_found_gron: "SEGNO VERDE",
    dp_found_blaa: "SEGNO BLU",
    dp_found_guld: "MONETA D'ORO",
    dp_res_win1: "HAI VINTO UN ORSETTO!",
    dp_res_win: "HAI VINTO {n} ORSETTI!",
    dp_res_none: "NESSUN ORSETTO STAVOLTA",
    dp_claim: "SCEGLI I TUOI ORSETTI",
    tile_pusher: "Spingimonete",
    pu_sign2: "100 MONETE D'ARGENTO",
    pu_lede: "Ricevi 100 monete d'argento. Calcola i tempi, spingi le monete oltre due bordi e scopri quante monete d'oro riesci a far uscire dalla macchina.",
    pu_rule1: "Tocca per rilasciare una moneta dalla fessura mobile",
    pu_rule2: "Le monete d'argento nella vaschetta tornano nella tua scorta",
    pu_rule3: "L'oro conta per il record. Le monete nelle scanalature laterali sono perse",
    pu_start: "GIOCA!",
    pu_hint: "Rilascia la moneta mentre lo spintore è arretrato",
    pu_last: "Le ultime monete rotolano...",
    pu_silver: "Argento",
    pu_gold: "Oro",
    pu_res_title: "{n} MONETE D'ORO!",
    pu_res_title1: "1 MONETA D'ORO!",
    pu_goldrain: "PIOGGIA D'ORO!",
    tile_hammer: "La prova di forza",
    hm_sign2: "SUONA LA CAMPANA",
    hm_lede: "Tre passi con un tocco ciascuno: alza il martello, carica la forza e colpisci la pedana al centro. Se prendi il verde, il disco vola verso la campana!",
    hm_rule1: "Sollevamento (300) e forza (300): ferma la lancetta nella zona VERDE",
    hm_rule2: "Mira (400): più vicino alla linea centrale, più in alto vola il disco",
    hm_rule3: "Oltre 900 punti: la campana suona e scegli un orsetto GRANDE",
    hm_start: "DAI COL MARTELLO!",
    hm_prizenote: "Un solo premio: l'orsetto GRANDE oltre 900 punti. Ogni punteggio conta per il record.",
    hm_ph_pull: "Alza",
    hm_ph_power: "Forza",
    hm_ph_aim: "Mira",
    hm_hint_pull: "Tocca quando la lancetta è nel verde",
    hm_hint_power: "Tocca nella zona verde, è la migliore",
    hm_hint_aim: "Colpisci il più vicino possibile al centro",
    hm_bell: "LA CAMPANA SUONA!",
    hm_res_great: "COLPACCIO!",
    hm_res_ok: "BEL COLPO!",
    hm_res_low: "IL DISCO SI È VERGOGNATO",
    hm_best: "Record: {n}",
    tile_bump: "Autoscontri",
    bp_sign2: "SPINGILI FUORI",
    bp_lede: "Sumo in autoscontro: spingi gli altri oltre il bordo dell'arena. Sopravvivi tra i primi 3 nel turno iniziale e batti i bot tosti in finale.",
    bp_rule1: "Guida con il joystick, i tocchi laterali o le frecce, l'auto accelera da sola",
    bp_rule2: "Turno iniziale: 6 auto, le ultime 3 passano in finale",
    bp_rule3: "Finale: chi vince prende il TROFEO D'ORO, 2° e 3° un orsetto medio",
    bp_start: "VIA ALLA SFIDA!",
    bp_round1: "TURNO INIZIALE",
    bp_final: "LA FINALE",
    bp_go: "VIA!",
    bp_left: "{n} auto rimaste",
    bp_out: "{name} è fuori!",
    bp_you_out: "SEI CADUTO!",
    bp_qualified: "AVANTI IN FINALE!",
    bp_res_win: "VINCITORE DELLA FINALE!",
    bp_res_win_sub: "Li hai spinti fuori tutti e vinci il trofeo d'oro!",
    bp_res_second: "A UN PASSO DAL TITOLO!",
    bp_res_out: "FUORI AL TURNO INIZIALE",
    ld_g_hammer: "La classica prova di forza: tre tocchi controllano sollevamento, forza e mira su una barra rossa, arancione e verde. Prendi sempre il verde, la campana suona e l'orsetto grande è tuo.",
    ld_g_bump: "Sumo in autoscontro: spingi i bot oltre il bordo dell'arena rotonda in due turni. Sopravvivi al turno iniziale, vinci la finale contro i bot tosti e prenditi il trofeo d'oro.",
    pu_res_note: "L'argento è finito e la macchina è ferma. Il tuo oro conta per il record.",
    ld_g_duck: "Pesca magnetica in uno stagno vivo: pesca 10 papere e girale. Tre segni uguali sul fondo vincono un orsetto, tre monete d'oro un orsetto GRANDE.",
    ld_g_pusher: "Classico spingimonete a due livelli: 100 monete d'argento, spintori oscillanti e monete d'oro in bilico sul bordo. L'argento nella vaschetta si rilancia, l'oro conta per il record.",
    pb_challenge: "Sfida un amico", pb_copied: "Link copiato!",
    pb_share_text: "Ho fatto {n} punti a Colpisci il sacco in Teddy Chase. Battimi!",
    hm_share_text: "Ho fatto {n} punti alla Prova di forza in Teddy Chase. Battimi!",
    pb_ch_banner: "{name} ti sfida: {n} punti. Battilo!",
    pb_ch_beat: "Hai battuto {name}!", pb_ch_lost: "{name} è ancora in testa con {n} punti.",
    size_lille: "Piccolo", size_mellem: "Medio", size_stor: "Grande",
    color_neonpink: "Rosa", color_giftgroen: "Verde chiaro", color_elblaa: "Azzurro cielo",
    color_neonorange: "Arancione", color_skriggul: "Giallo sole", color_neonlilla: "Lavanda",
    color_turkis: "Menta", color_knaldroed: "Rosso corallo",
    type_bamse: "Orsetto", type_enhjoerning: "Unicorno", type_dino: "Dinosauro",
    type_blaeksprutte: "Polpo", type_froe: "Rana", type_kanin: "Coniglio",
    type_panda: "Panda", type_loeve: "Leone", type_elefant: "Elefante",
    type_pingvin: "Pinguino", type_haj: "Squalo", type_koala: "Koala",
    type_hund: "Cagnolino", type_giraf: "Giraffa", type_bjoern: "Orso",
    trophy: "Coppa d'oro",
    pp_ribbon: "PREMIO!",
    pp_won: "Hai vinto un peluche ({size}), scegli il tuo preferito:",
    pr_title: "SALA PREMI",
    pr_count_one: "premio", pr_count_many: "premi",
    pr_tip: "Tieni premuto un peluche e trascinalo dove vuoi",
    pr_empty: "Gli scaffali sono vuoti…",
    pr_empty2: "Vinci il tuo primo peluche!",
    lb_title: "CLASSIFICA",
    lb_name: "Nome", lb_trophies: "Coppe", lb_plush: "Peluche", lb_total: "Totale",
    lb_empty: "Nessuno in classifica, vai a vincere!",
    lb_note: "Globale",
    lb_loading: "Carico la classifica…",
    lb_offline: "Impossibile caricare la classifica globale, controlla la connessione.",
    name_device_note: "Questo dispositivo ha un posto nella classifica globale, un nuovo nome prende quel posto.",
    h_sign2: "2 PALLINE ALLA VOLTA",
    h_lede: "Prendi le palline dalla vaschetta e mettile sulla linea di partenza, la posizione decide l'angolo! Falle rotolare su per la rampa e vola oltre il bordo: ogni buca fa avanzare il tuo cavallo. Il primo a {goal} vince la corsa e un premio!",
    h_opponents: "Avversari",
    h_difficulty: "Difficoltà",
    diff_let: "Facile", diff_mellem: "Medio", diff_svaer: "Difficile",
    h_track_let: "Pista: La Classica, tavola aperta e tiro libero al 3 rosso",
    h_track_mellem: "Pista: Doppio Oro. DUE 3 rossi negli angoli in fondo, ognuno protetto da un paletto",
    h_track_svaer: "Pista: Il Guardiano, tre paletti bloccano il tiro diretto al rosso (vola sopra o gira intorno!)",
    h_prizenote: "Premi: Facile = piccoli · Medio = piccoli e medi · Difficile = tutti, e più avversari hai, più è facile vincere i GRANDI!",
    h_start: "Via alla corsa",
    h_legend_red: "Rosso = 3", h_legend_blue: "Blu = 2", h_legend_yellow: "Giallo = 1",
    h_yourhorse: "Il tuo cavallo:",
    h_last: "Ultima pallina: +{pts}",
    h_win: "HAI VINTO!", h_lose: "LA CORSA È FINITA",
    h_wonrace: "ha vinto la corsa!",
    h_noprize: "Niente premio stavolta, riprova!",
    h_points: "punti",
    h_hint_take: "Prendi una pallina dalla vaschetta e mettila tra le linee",
    h_hint_move: "Sposta la pallina liberamente, trascina indietro per tirare!",
    f_sign2: "{shots} TIRI, {need} GOL = PREMIO",
    f_lede: "Hai {shots} tiri contro il portiere, scivola avanti e indietro ma non arriva agli angoli. Trascina in curva per dare effetto e aggirarlo!",
    f_rule1: "{shots} tiri, almeno {need} gol per un premio",
    f_rule2: "Il portiere si muove, finta dopo 2 gol, accelera dopo 3, e sull'ultimo tiro dà TUTTO!",
    f_rule3: "Effetto: trascina il dito in curva e il tiro gira",
    f_rule4: "Piena potenza (barra rossa) = rischio traversa!",
    f_prizenote: "Premio per gol: 3-4 = piccolo · 5 = medio · 6-7 = GRANDE · tutti e 8 = COPPA D'ORO!",
    f_start: "Fischio d'inizio",
    f_goals: "Gol:", f_shots: "Tiro {n} / {max}",
    f_win: "CHE PIEDE!", f_fail: "HA VINTO IL PORTIERE!",
    f_winline: "{goals} gol su {shots} tiri!",
    f_failline: "{goals} gol su {shots} tiri, ne servivano {need}. Riprova!",
    f_trophy_ribbon: "COPPA D'ORO!",
    f_trophyline: "Tutti e {shots} i gol! La coppa d'oro è ora sullo scaffale più alto della tua sala premi!",
    f_hint: "Prendi un pallone, trascina in curva per l'effetto!",
    f_banner: "{shots} TIRI. ALMENO {need} GOL!",
    f_hattrick: "TRIPLETTA!",
    f_hattrick2: "DOPPIA TRIPLETTA!",
    f_hattrick_sub: "{n} GOL • {n} TIRI",
    f_curve: "EFFETTO",
    tray_empty: "VUOTO",
    b_sign2: "3 LIVELLI CONTRO IL TEMPO",
    b_lede: "Il tempo è il tuo avversario! Hai 30 secondi a livello: fai canestro {n1}, poi {n2} e in finale {n3} volte. Il canestro si muove al livello 2 e in finale!",
    b_rule1: "Livello 1, fai {n} canestri in 30 sec. (il canestro è fermo)",
    b_rule2: "Livello 2, fai {n} canestri in 30 sec. (il canestro scorre)",
    b_rule3: "La finale, fai {n} canestri in 30 sec. (canestro veloce, e hai una palla in più!)",
    b_prizenote: "Premio: Completa tutti e tre i livelli e vinci un peluche medio, sempre, in questo stand.",
    b_start: "Via al cronometro",
    b_level: "Livello", b_final: "La finale",
    b_of: "Livello {n} di {max}",
    b_win: "HAI BATTUTO IL TEMPO!",
    b_winline: "Tutti i {n} livelli completati!",
    b_fail: "TEMPO SCADUTO!",
    b_failline: "Sei arrivato a {level}, niente premio stavolta.",
    b_hint: "Prendi una palla dalla vaschetta e mettila tra le linee",
    b_banner1: "FAI {n} CANESTRI IN 30 SEC!",
    b_banner2: "{level}. FAI {n} IN 30 SEC!",
    b_banner3: "FINALE. FAI {n} · PALLA EXTRA!",
    s_sign2: "{shots} COLPI. COLPISCI I MOSTRI",
    s_lede: "I mostri sfilano su tre file, più sono lontani, più vanno veloci! Hai {shots} colpi. Colpiscine più che puoi!",
    s_rule1: "{shots} colpi, colpisci 7 mostri per un peluche piccolo",
    s_rule2: "8 colpiti = peluche medio · 9 = peluche GRANDE",
    s_rule3: "Le zucche in fondo si rialzano, il resto rimane giù!",
    s_rule4: "Tutti e 10 = COPPA D'ORO!",
    s_trophy_ribbon: "COPPA D'ORO!",
    s_trophyline: "Tutti e {shots} i mostri colpiti! La coppa d'oro è ora sullo scaffale più alto della tua sala premi!",
    s_prizenote: "La pallina colpisce il primo mostro sul suo cammino, punta alle file veloci, se hai coraggio!",
    s_start: "Pronti, mira, fuoco",
    s_hits: "Colpiti:", s_shots: "Colpo {n} / {max}",
    s_win: "CHE MIRA!",
    s_fail: "I MOSTRI SONO SCAPPATI!",
    s_winline: "{hits} mostri su {shots} colpiti!",
    s_failline: "Solo {hits} colpiti, ne servivano 7. Riprova!",
    s_hint: "Prendi una pallina e spara ai mostri!",
    s_banner: "COLPISCI I MOSTRI!",
    tile_claw: "Gru dei peluche",
    c_sign2: "3 TENTATIVI OGNI 15 MIN",
    c_lede: "La gru va avanti e indietro sopra il mucchio, tocca quando è sopra il tuo peluche preferito e incrocia le dita per una buona presa!",
    c_rule1: "Tocca per far scendere la gru",
    c_rule2: "Se prendi bene, il peluche viene su con lei",
    c_rule3: "3 tentativi ogni quarto d'ora, così la macchina non si svuota",
    c_prizenote: "Premio: il piccolo peluche che peschi, esattamente come lo vedi!",
    c_start: "Avvia la macchina",
    c_tries: "Tentativi: {n} / 3",
    c_wait: "Prossimo tentativo tra {t}",
    c_hint: "Tocca per far scendere la gru!",
    c_locked: "La macchina riposa, torna tra {t}",
    c_win: "CHE PRESA!",
    c_missline: "La gru ha mollato la presa… riprova!",
    c_done_won: "Hai pescato {n} peluche, ora sono nella tua sala premi!",
    c_done_won1: "Hai pescato 1 peluche, ora è nella tua sala premi!",
    c_done_zero_title: "PRESA VUOTA!",
    c_done_zero: "La gru non ha preso niente stavolta, andrà meglio la prossima!",
    ad_offer_claw: "La gru si ricarica… oppure guarda un breve video e riparti subito con 6 nuovi tentativi!",
    ad_watch: "Guarda il video",
    ad_no: "No grazie",
    ad_fail: "Il video non è disponibile, riprova più tardi.",
    ad_bonus: "+{n} tentativi bonus",
    ad_label: "Annuncio",
    doc_title: "Teddy Chase – giochi gratis: corsa dei cavalli, gru dei peluche e altro",
    ad_offer_double: "Raddoppia! Guarda un breve video e rendi il tuo premio {size}.",
    ad_upgraded: "Premio migliorato, scegli il tuo peluche!",
    ad_offer_cans_title: "CI SEI QUASI!",
    ad_offer_cans: "{n} barattoli rimasti, guarda un breve video e prendi 1 palla extra!",
    ad_offer_football: "A un gol da un premio migliore! Guarda un breve video e ottieni 1 tiro extra.",
    ad_offer_shoot: "A un colpo da un premio migliore! Guarda un breve video e ottieni 1 tiro extra.",
    ad_offer_basket: "Guarda un breve video e riprova {level} col tempo azzerato!",
    pop_grab: "PRESO!", pop_slip: "SCIVOLATO!",
    tile_wheel: "Ruota della fortuna",
    w_sign2: "INDOVINA 3 NUMERI SU 20",
    w_lede: "Scegli 3 numeri e gira la grande ruota, se la freccia si ferma su uno dei tuoi, vinci un peluche medio! I numeri hanno lo stesso colore del loro spicchio.",
    w_pick: "Scegli ancora {n} numeri",
    w_ready: "Pronto a girare!",
    w_spin: "GIRA LA RUOTA",
    w_spinning: "La ruota gira…",
    w_win: "NUMERO FORTUNATO!",
    w_winline: "La ruota si è fermata sul {n}, uno dei tuoi!",
    w_lose: "NON STAVOLTA",
    w_loseline: "La ruota si è fermata sul {n}. Scegli i numeri e riprova!",
    w_prizenote1: "Premio: un peluche medio",
    w_prizenote2: "3 su 20, la fortuna aiuta gli audaci!",
    tile_race: "Auto da corsa",
    rc_sign2: "PRIMO A {laps} GIRI",
    rc_lede: "Corsa di autoscontri vista dall'alto! Guida sul circuito, raccogli i boost e spingi pure gli altri, il primo a {laps} giri vince.",
    rc_rule1: "Guida col joystick nell'angolo (o con le frecce)",
    rc_rule2: "Passa su un boost per una bella spinta in avanti",
    rc_rule3: "Gli scontri sono permessi, spingi i rivali contro il muro!",
    rc_prizenote: "Facile = piccolo · Medio = medio · Difficile = COPPA D'ORO",
    rc_start: "VIA ALLA CORSA",
    rc_ready: "PRONTI…",
    rc_go: "VIA!",
    rc_track: "Pista",
    rc_track_oval: "Ovale", rc_track_heart: "Pista Cuore", rc_track_tri: "Triangolo",
    rc_lap: "Giro {n}/{max}",
    rc_lapup: "GIRO {n}/{max}",
    rc_pos: "Pos. {n}",
    rc_boost: "BOOST!",
    rc_win: "VITTORIA!",
    rc_winline: "1º posto, hai vinto la corsa!",
    rc_finishpop: "ARRIVO!",
    rc_trophy_ribbon: "COPPA DEL CAMPIONE!",
    rc_trophyline: "Hai vinto in Difficile, la coppa è ora nella tua sala premi!",
    rc_fail: "BANDIERA A SCACCHI",
    rc_failline: "Sei arrivato {n}º, torna al volante!",
    tile_hang: "Hangtime",
    ht_sign2: "MANTIENI L'EQUILIBRIO",
    ht_lede: "Il funambolo cammina sulla corda, in alto sopra la pista. Tieni l'ago nella zona verde, se pende troppo, finisce nella rete! Il vento rende tutto sempre più difficile.",
    ht_rule1: "Tieni l'ago nella zona verde dell'indicatore",
    ht_rule2: "Attento alle raffiche, arrivano da entrambi i lati",
    ht_rule3_mouse: "Muovi il mouse ai lati per inclinarlo, o usa le frecce",
    ht_rule3_touch: "Inclina il telefono, o tieni premuti i lati dello schermo",
    ht_prizenote: "{lille}s=piccolo · {mellem}s=medio · {stor}s=grande · {pokal}s=COPPA D'ORO",
    ht_start_mouse: "SULLA CORDA",
    ht_start_gyro: "GIOCA INCLINANDO",
    ht_start_touch: "Gioca coi tocchi laterali",
    ht_mode_gyro: "INCLINA",
    ht_mode_mouse: "MOUSE",
    ht_mode_touch: "TOCCO",
    ht_gyro_denied: "Impossibile usare l'inclinazione del telefono, usa i tocchi laterali.",
    ht_crossings: "Traversate: {n}",
    ht_cross: "TRAVERSATA {n}!",
    ht_win: "CHE EQUILIBRIO!",
    ht_winline: "Sei rimasto su per {s} secondi!",
    ht_trophy_ribbon: "LEGGENDA DEL FILO!",
    ht_trophyline: "{s} secondi sulla corda, la coppa è ora nella tua sala premi!",
    ht_fail: "NELLA RETE",
    ht_failline: "{s} secondi, te ne servono {need} per un premio. Torna sulla corda!",
    tile_cans: "Butta giù i barattoli",
    cn_sign2: "{shots} LANCI",
    cn_lede: "Dieci barattoli di latta in piramide, butta GIÙ dal tavolo tutta la torre in massimo {shots} lanci! Meno lanci usi, meglio è il premio.",
    cn_rule1: "Trascina in GIÙ e rilascia per lanciare la palla",
    cn_rule2: "I barattoli contano solo quando sono DEL TUTTO giù dal tavolo",
    cn_rule3: "La piena potenza non è sempre la migliore, mira alla base!",
    cn_prizenote: "2 lanci = COPPA D'ORO · 3 = grande · 4 = medio · 5 = piccolo",
    cn_start: "LANCIA",
    cn_cans: "Barattoli rimasti: {n}",
    cn_shots: "Lancio {n}/{max}",
    cn_out: "FUORI!",
    cn_win: "TORRE ABBATTUTA!",
    cn_winline: "Tutti e 10 i barattoli giù in {n} lanci!",
    cn_trophy_ribbon: "RE DEI BARATTOLI!",
    cn_trophyline: "Tutta la torre in soli {n} lanci, la coppa è tua!",
    cn_fail: "LA TORRE RESISTE",
    cn_failline: "{n} barattoli sono sopravvissuti, nuova torre, nuove chance!",
    tile_mole: "Acchiappa la talpa",
    mo_sign2: "{s} SECONDI",
    mo_lede: "Le talpe sbucano dai buchi, colpiscile prima che si rituffino giù! Hai {s} secondi, e si va sempre più veloce.",
    mo_rule1: "Tocca le talpe finché sono su",
    mo_rule2: "Le talpe dorate valgono 3 punti",
    mo_rule3: "Il ritmo aumenta, mantieni la calma alla fine",
    mo_prizenote: "{lille}=piccolo · {mellem}=medio · {stor}=grande · {pokal}=COPPA D'ORO",
    mo_start: "VIA ALLA CACCIA",
    mo_hits: "Colpite: {n}",
    mo_win: "CHE CACCIA!",
    mo_winline: "Hai colpito {n} talpe!",
    mo_trophy_ribbon: "MAESTRO DELLE TALPE!",
    mo_trophyline: "{n} talpe nel tempo limite, la coppa è ora nella tua sala premi!",
    mo_fail: "SONO SCAPPATE",
    mo_failline: "Ne hai colpite {n}, te ne servono almeno {need} per un premio. Riprova!",
    names_horse: ["Lampo", "Zuccherino", "Baron Trotto", "Miss Veloce", "Zoccolodoro", "Principino", "Madama Mula", "Fulmine Lia", "Avena Aldo", "Conte Galoppo"],
    names_race: ["Gas-Gino", "Turbo-Ugo", "Benzina", "Ottavio", "Freno-Pia", "Nitro-Nio", "Sfreccia", "Zoom-Zita", "Ruota-Rai", "Pit-Pippo"],
    pop_goal: "GOL!", pop_saved: "PARATA!", pop_post: "PALO!", pop_over: "TRAVERSA!",
    pop_basket: "CANESTRO!", pop_hit: "COLPITO!",
  },
  fr: {
    menu_welcome: "BIENVENUE À LA FÊTE FORAINE",
    menu_allwin: "TOUT LE MONDE PEUT GAGNER",
    play: "JOUER",
    tile_horse: "Course de chevaux",
    tile_football: "Football",
    tile_basket: "Basket",
    tile_shoot: "Stand de tir",
    tile_prizes: "Salle des lots",
    tile_board: "Classement",
    prizes_one: "LOT",
    prizes_many: "LOTS",
    board_go: "CLASSEMENT",
    footer_privacy: "Confidentialité",
    name_q: "Comment tu t'appelles ?",
    name_note: "Ton nom apparaît au classement et sur la piste. Prends plutôt un surnom, tous les joueurs peuvent le voir.",
    name_ph: "Ton nom",
    name_save: "ENREGISTRER",
    name_err_len: "Le nom doit faire 2 à 12 caractères.",
    name_err_rude: "On ne peut pas graver ça sur la coupe… essaie autre chose.",
    back: "‹ Menu",
    sign_free: "GRATUIT",
    play_again: "Rejouer",
    try_again: "Réessayer",
    to_menu: "Au menu",
    your_prize: "Ton lot :",
    in_room: "– il est maintenant dans ta salle des lots !",
    you: "Toi",
    ld_h1: "Teddy Chase – stands classiques de fête foraine et jeux amusants en ligne",
    ld_intro: "Teddy Chase est une collection gratuite de quinze stands classiques de fête foraine, à jouer directement dans le navigateur, sur mobile, tablette et ordinateur, sans téléchargement et sans achats. Gagne des peluches aux couleurs joyeuses et des trophées dorés brillants, remplis ta salle des prix et bats-toi pour une place au classement mondial. Le jeu existe en six langues : danois, anglais, allemand, italien, français et espagnol.",
    ld_g_horse: "Le roi des stands : fais rouler les boules sur la rampe et vise les trous, chaque point fait avancer ton cheval vers l'arrivée. Trois pistes, des quilles bloquantes et jusqu'à cinq adversaires.",
    ld_g_claw: "La pince à peluches classique en ligne : appuie au bon moment et pêche exactement la peluche que tu vois dans le tas. Trois essais par quart d'heure, alors soigne-les.",
    ld_g_shoot: "Un stand de tir comme à la vraie fête foraine : trois rangées de monstres en mouvement, touches-en 7 pour un prix, touche les 10 et prends le trophée d'or.",
    ld_g_wheel: "Choisis 3 des 20 numéros de la roue et fais-la tourner. Si la flèche s'arrête sur ton numéro, la peluche moyenne est à toi.",
    ld_g_race: "Course de voitures téléguidées vue du dessus avec joystick, boosts et coups de coude, trois circuits, cinq tours, et un trophée d'or pour la victoire en Difficile.",
    ld_g_football: "Huit tirs contre un gardien qui feinte et accélère. Enroule le ballon autour de lui, huit buts d'affilée valent le trophée, avec des célébrations de coup du chapeau en chemin.",
    ld_g_basket: "Trois niveaux contre la montre avec un panier qui glisse de plus en plus vite. Réussis la finale et choisis ta peluche.",
    ld_g_mole: "60 secondes, neuf trous et des taupes de plus en plus rapides, les dorées valent trois points, et les curieuses sont presque impossibles à attraper.",
    ld_g_cans: "Chamboule-tout avec une vraie physique : fais tomber toute la pyramide de la table en cinq lancers. Réussis en deux et le trophée d'or t'attend.",
    ld_g_hang: "Garde le funambule en équilibre dans le vent, à la souris, aux flèches ou en inclinant le téléphone. Plus tu tiens longtemps, plus le prix est gros.",
    ld_g_punch: "Quatre étapes, un appui chacune : recule parfaitement, arme ton bras, trouve la puissance et vole dans le sac de frappe. Jusqu'à 1 000 points, et tu peux envoyer le défi à un ami.",
    ld_g_exchange: "Les étagères débordent ? Échange 100 peluches contre une pièce d'or à l'effigie de l'ours du logo. La pièce vaut 100 prix, ta place au classement ne change pas.",
    ld_faq_h: "Questions fréquentes",
    ld_q1: "Les jeux sont-ils gratuits ?",
    ld_a1: "Oui, les quinze stands sont entièrement gratuits, et il n'y a aucun achat dans le jeu.",
    ld_q2: "Puis-je jouer sur mobile ?",
    ld_a2: "Oui, les jeux sont faits pour le mobile : contrôles tactiles, joystick et gyroscope, et ils marchent aussi bien sur tablette et ordinateur.",
    ld_q3: "En quelles langues le jeu existe-t-il ?",
    ld_a3: "Danois, anglais, allemand, italien, français et espagnol. La langue est choisie automatiquement selon ton navigateur et peut toujours être changée avec le bouton drapeau.",
    ld_q4: "Que peut-on gagner ?",
    ld_a4: "Des peluches en trois tailles et des trophées d'or, rassemblés dans ta salle des prix, et tes gains comptent au classement mondial.",
    tile_punch: "Frappe le sac", tile_exchange: "Bourse aux peluches", ex_go: "À LA BOURSE",
    ex_coin_one: "pièce d'or", ex_coin_many: "pièces d'or",
    ex_lede: "Échange {n} peluches contre 1 pièce d'or à l'effigie de l'ours du logo. La pièce vaut {n} prix au tableau, ton total ne change pas. Et tes étagères respirent !",
    ex_missing: "Gagne encore {n} peluches pour pouvoir échanger.",
    ex_ready: "Tu en as assez. Prêt à échanger !",
    ex_cta: "Échanger {n} peluches contre 1 pièce d'or",
    ex_note: "Les trophées ne sont jamais touchés. 1 pièce d'or = {n} prix au classement.",
    ex_confirm_t: "Tu es sûr ?",
    ex_confirm: "Tu donnes {n} peluches (les plus petites et anciennes d'abord) et tu reçois 1 pièce d'or dans la salle des prix.",
    ex_yes: "Échanger", ex_no: "Annuler",
    ex_done_t: "Félicitations !", ex_done: "Tu as une pièce d'or ! Elle trône en haut de la salle des prix.",
    ex_more: "Échanger encore",
    pb_sign2: "0-1 000 POINTS",
    pb_lede: "Quatre étapes, un appui chacune : recule parfaitement, arme ton bras, trouve la puissance et frappe en plein centre. Jusqu'à 1 000 points, seul ton record compte.",
    pb_rule1: "1. Recule et arrête-toi sur la marque (200 points)",
    pb_rule2: "2. Arme ton bras (200 points)",
    pb_rule3: "3. Arrête la puissance au sommet (300 points)",
    pb_rule4: "4. Frappe le sac en plein centre (300 points)",
    pb_prizenote: "Pas de prix ici, juste la gloire : bats ton record et défie un ami.",
    pb_best: "Record : {n}", pb_start: "DING DING !",
    pb_hint_walk: "Appuie quand l'ours est sur la marque !",
    pb_hint_windup: "Appuie au sommet de l'élan !",
    pb_hint_power: "Appuie quand la puissance est dans la zone dorée !",
    pb_hint_aim: "Appuie quand le viseur est au centre du sac !",
    pb_ph_walk: "Distance", pb_ph_windup: "Élan", pb_ph_power: "Puissance", pb_ph_aim: "Visée",
    pb_res_great: "COUP DE MAÎTRE !", pb_res_ok: "Beau coup !", pb_res_low: "Échauffe-toi encore",
    pb_res_ko: "LE SAC A EXPLOSÉ !",
    pb_hs_btn: "Meilleurs scores",
    pb_hs_month: "Ce mois-ci",
    pb_hs_all: "Historique",
    pb_hs_empty: "Pas encore de scores",
    pb_hs_err: "Impossible de charger la liste",
    pb_hs_close: "Fermer",
    tile_duck: "La mare aux canards",
    dp_sign2: "PÊCHE 10 CANARDS",
    dp_lede: "Plonge l'aimant dans la mare et pêche 10 canards. La marque sous le canard décide du prix, et 3 marques identiques gagnent un ours en peluche !",
    dp_rule1: "Marque verte : 3 identiques = petit ours",
    dp_rule2: "Marque bleue : 3 identiques = ours moyen. Pièce d'or : 3 identiques = GRAND ours",
    dp_rule3: "Joker : ne gagne rien, plus de chance au prochain canard",
    dp_start: "À LA PÊCHE !",
    dp_hint: "Vise avec l'aimant et touche pour pêcher",
    dp_fished: "Pêchés : {n}/{m}",
    dp_joker: "JOKER",
    dp_found_gron: "MARQUE VERTE",
    dp_found_blaa: "MARQUE BLEUE",
    dp_found_guld: "PIÈCE D'OR",
    dp_res_win1: "TU AS GAGNÉ UN OURS !",
    dp_res_win: "TU AS GAGNÉ {n} OURS !",
    dp_res_none: "PAS D'OURS CETTE FOIS",
    dp_claim: "CHOISIS TES PELUCHES",
    tile_pusher: "Pousse-pièces",
    pu_sign2: "100 PIÈCES D'ARGENT",
    pu_lede: "Tu reçois 100 pièces d'argent. Chronomètre tes lâchers, pousse les pièces par-dessus deux bords et vois combien de pièces d'or tu peux extraire de la machine.",
    pu_rule1: "Touche pour lâcher une pièce depuis la fente mobile",
    pu_rule2: "Les pièces d'argent dans le bac retournent dans ta réserve",
    pu_rule3: "L'or compte pour le record. Les pièces dans les gouttières latérales sont perdues",
    pu_start: "JOUER !",
    pu_hint: "Lâche la pièce quand le poussoir est reculé",
    pu_last: "Les dernières pièces roulent...",
    pu_silver: "Argent",
    pu_gold: "Or",
    pu_res_title: "{n} PIÈCES D'OR !",
    pu_res_title1: "1 PIÈCE D'OR !",
    pu_goldrain: "PLUIE D'OR !",
    tile_hammer: "La force du marteau",
    hm_sign2: "SONNE LA CLOCHE",
    hm_lede: "Trois étapes, un tap chacune : lève le marteau, charge ta force et frappe le plot en plein centre. Vise le vert et le palet file vers la cloche !",
    hm_rule1: "Levée (300) et force (300) : arrête l'aiguille dans la zone VERTE",
    hm_rule2: "Visée (400) : plus près de la ligne centrale, plus le palet monte",
    hm_rule3: "Au-dessus de 900 points : la cloche sonne et tu choisis un GRAND ours",
    hm_start: "BALANCE LE MARTEAU !",
    hm_prizenote: "Un seul prix : le GRAND ours au-dessus de 900 points. Chaque score compte pour le record.",
    hm_ph_pull: "Levée",
    hm_ph_power: "Force",
    hm_ph_aim: "Visée",
    hm_hint_pull: "Tape quand l'aiguille est dans le vert",
    hm_hint_power: "Tape dans la zone verte, c'est la meilleure",
    hm_hint_aim: "Frappe aussi près du centre que possible",
    hm_bell: "LA CLOCHE SONNE !",
    hm_res_great: "COUP DE MAÎTRE !",
    hm_res_ok: "BEAU COUP !",
    hm_res_low: "LE PALET A BOUDE",
    hm_best: "Record : {n}",
    tile_bump: "Autos tamponneuses",
    bp_sign2: "POUSSE-LES DEHORS",
    bp_lede: "Sumo en autos tamponneuses : pousse les autres par-dessus le bord de l'arène. Survis dans le top 3 du tour initial, puis bats les bots coriaces en finale.",
    bp_rule1: "Dirige avec le joystick, les taps sur les côtés ou les flèches, la voiture accélère toute seule",
    bp_rule2: "Tour initial : 6 voitures, les 3 dernières passent en finale",
    bp_rule3: "La finale : le vainqueur prend le TROPHÉE D'OR, les 2e et 3e un ours moyen",
    bp_start: "LANCE LE DUEL !",
    bp_round1: "TOUR INITIAL",
    bp_final: "LA FINALE",
    bp_go: "GO !",
    bp_left: "{n} voitures restantes",
    bp_out: "{name} est sorti !",
    bp_you_out: "TU ES TOMBÉ !",
    bp_qualified: "EN ROUTE POUR LA FINALE !",
    bp_res_win: "VAINQUEUR DE LA FINALE !",
    bp_res_win_sub: "Tu les as tous poussés dehors et tu gagnes le trophée d'or !",
    bp_res_second: "SI PRÈS DU TITRE !",
    bp_res_out: "SORTI AU TOUR INITIAL",
    ld_g_hammer: "La force du marteau classique : trois taps contrôlent levée, force et visée sur une barre rouge, orange et verte. Reste dans le vert, la cloche sonne et le grand ours est à toi.",
    ld_g_bump: "Sumo en autos tamponneuses : pousse les bots par-dessus le bord de l'arène ronde en deux manches. Survis au tour initial, gagne la finale contre les bots coriaces et prends le trophée d'or.",
    pu_res_note: "L'argent est épuisé et la machine est immobile. Ton or compte pour le record.",
    ld_g_duck: "Pêche magnétique dans une mare vivante : pêche 10 canards et retourne-les. Trois marques identiques dessous gagnent un ours, trois pièces d'or un GRAND ours.",
    ld_g_pusher: "Pousse-pièces classique à deux niveaux : 100 pièces d'argent, des poussoirs oscillants et des pièces d'or au bord du vide. L'argent du bac se relance, l'or compte pour le record.",
    pb_challenge: "Défier un ami", pb_copied: "Lien copié !",
    pb_share_text: "J'ai fait {n} points à Frappe le sac dans Teddy Chase. Bats-moi !",
    hm_share_text: "J'ai fait {n} points à La force du marteau dans Teddy Chase. Bats-moi !",
    pb_ch_banner: "{name} te défie : {n} points. Bats-le !",
    pb_ch_beat: "Tu as battu {name} !", pb_ch_lost: "{name} mène encore avec {n} points.",
    size_lille: "Petit", size_mellem: "Moyen", size_stor: "Grand",
    color_neonpink: "Rose", color_giftgroen: "Vert clair", color_elblaa: "Bleu ciel",
    color_neonorange: "Orange", color_skriggul: "Jaune soleil", color_neonlilla: "Lavande",
    color_turkis: "Menthe", color_knaldroed: "Rouge corail",
    type_bamse: "Nounours", type_enhjoerning: "Licorne", type_dino: "Dinosaure",
    type_blaeksprutte: "Pieuvre", type_froe: "Grenouille", type_kanin: "Lapin",
    type_panda: "Panda", type_loeve: "Lion", type_elefant: "Éléphant",
    type_pingvin: "Pingouin", type_haj: "Requin", type_koala: "Koala",
    type_hund: "Toutou", type_giraf: "Girafe", type_bjoern: "Ours",
    trophy: "Coupe en or",
    pp_ribbon: "LOT !",
    pp_won: "Tu as gagné une peluche ({size}), choisis ta préférée :",
    pr_title: "SALLE DES LOTS",
    pr_count_one: "lot", pr_count_many: "lots",
    pr_tip: "Appuie longtemps sur une peluche pour la déplacer",
    pr_empty: "Les étagères sont vides…",
    pr_empty2: "Va gagner ta première peluche !",
    lb_title: "CLASSEMENT",
    lb_name: "Nom", lb_trophies: "Coupes", lb_plush: "Peluches", lb_total: "Total",
    lb_empty: "Personne au tableau, va gagner !",
    lb_note: "Mondial",
    lb_loading: "Chargement du classement…",
    lb_offline: "Impossible de charger le classement mondial, vérifie ta connexion.",
    name_device_note: "Cet appareil a une place au classement mondial, un nouveau nom reprend cette place.",
    h_sign2: "2 BILLES À LA FOIS",
    h_lede: "Prends les billes dans le bac et pose-les sur la ligne de départ, la position choisit ton angle ! Fais-les rouler sur la rampe et vole par-dessus le bord : chaque trou fait avancer ton cheval. Le premier à {goal} gagne la course et un lot !",
    h_opponents: "Adversaires",
    h_difficulty: "Difficulté",
    diff_let: "Facile", diff_mellem: "Moyen", diff_svaer: "Difficile",
    h_track_let: "Piste : La Classique, plateau ouvert et tir direct sur le 3 rouge",
    h_track_mellem: "Piste : Double Or. DEUX 3 rouges au fond dans les coins, chacun gardé par un plot",
    h_track_svaer: "Piste : Le Gardien, trois plots bloquent le tir direct sur le rouge (vole au-dessus ou contourne !)",
    h_prizenote: "Lots : Facile = petits · Moyen = petits et moyens · Difficile = tous, et plus tu as d'adversaires, plus tu as de chances de gagner les GRANDS !",
    h_start: "Départ de la course",
    h_legend_red: "Rouge = 3", h_legend_blue: "Bleu = 2", h_legend_yellow: "Jaune = 1",
    h_yourhorse: "Ton cheval :",
    h_last: "Dernière bille : +{pts}",
    h_win: "TU AS GAGNÉ !", h_lose: "LA COURSE EST FINIE",
    h_wonrace: "a gagné la course !",
    h_noprize: "Pas de lot cette fois, réessaie !",
    h_points: "points",
    h_hint_take: "Prends une bille dans le bac et pose-la entre les lignes",
    h_hint_move: "Déplace la bille librement, tire vers l'arrière pour lancer !",
    f_sign2: "{shots} TIRS, {need} BUTS = LOT",
    f_lede: "Tu as {shots} tirs contre le gardien, il glisse de gauche à droite mais n'atteint pas les coins. Trace une courbe pour brosser le ballon et le contourner !",
    f_rule1: "{shots} tirs, au moins {need} buts pour un lot",
    f_rule2: "Le gardien bouge, feinte après 2 buts, accélère après 3, et sur le dernier tir il donne TOUT !",
    f_rule3: "Effet : trace une courbe avec ton doigt et le tir tourne",
    f_rule4: "Pleine puissance (barre rouge) = risque de barre transversale !",
    f_prizenote: "Lot selon les buts : 3-4 = petit · 5 = moyen · 6-7 = GRAND · les 8 = COUPE EN OR !",
    f_start: "Coup d'envoi",
    f_goals: "Buts :", f_shots: "Tir {n} / {max}",
    f_win: "QUEL PIED !", f_fail: "LE GARDIEN A GAGNÉ !",
    f_winline: "{goals} buts en {shots} tirs !",
    f_failline: "{goals} buts en {shots} tirs, il en fallait {need}. Réessaie !",
    f_trophy_ribbon: "COUPE EN OR !",
    f_trophyline: "Les {shots} buts ! La coupe en or trône maintenant en haut de ta salle des lots !",
    f_hint: "Prends un ballon, trace une courbe pour brosser !",
    f_banner: "{shots} TIRS. AU MOINS {need} BUTS !",
    f_hattrick: "COUP DU CHAPEAU !",
    f_hattrick2: "DOUBLE COUP DU CHAPEAU !",
    f_hattrick_sub: "{n} BUTS • {n} TIRS",
    f_curve: "EFFET",
    tray_empty: "VIDE",
    b_sign2: "3 NIVEAUX CONTRE LA MONTRE",
    b_lede: "Le temps est ton adversaire ! Tu as 30 secondes par niveau : marque {n1}, puis {n2}, et {n3} paniers en finale. Le panier bouge au niveau 2 et en finale !",
    b_rule1: "Niveau 1, marque {n} en 30 sec. (le panier est immobile)",
    b_rule2: "Niveau 2, marque {n} en 30 sec. (le panier glisse)",
    b_rule3: "La finale, marque {n} en 30 sec. (panier rapide, et tu as un ballon en plus !)",
    b_prizenote: "Lot : Finis les trois niveaux et gagne une peluche moyenne, toujours, à ce stand.",
    b_start: "Lance le chrono",
    b_level: "Niveau", b_final: "La finale",
    b_of: "Niveau {n} sur {max}",
    b_win: "TU AS BATTU LE CHRONO !",
    b_winline: "Les {n} niveaux réussis !",
    b_fail: "TEMPS ÉCOULÉ !",
    b_failline: "Tu as atteint {level}, pas de lot cette fois.",
    b_hint: "Prends un ballon dans le bac et pose-le entre les lignes",
    b_banner1: "MARQUE {n} EN 30 SEC !",
    b_banner2: "{level}. MARQUE {n} EN 30 SEC !",
    b_banner3: "FINALE. MARQUE {n} · BALLON EN PLUS !",
    s_sign2: "{shots} TIRS. TOUCHE LES MONSTRES",
    s_lede: "Les monstres défilent sur trois rangées, plus ils sont loin, plus ils vont vite ! Tu as {shots} tirs. Touches-en un max !",
    s_rule1: "{shots} tirs, touche 7 monstres pour une petite peluche",
    s_rule2: "8 touchés = peluche moyenne · 9 = GRANDE peluche",
    s_rule3: "Les citrouilles du fond se relèvent, le reste tombe pour de bon !",
    s_rule4: "Les 10 = COUPE EN OR !",
    s_trophy_ribbon: "COUPE EN OR !",
    s_trophyline: "Les {shots} monstres touchés ! La coupe en or trône maintenant en haut de ta salle des lots !",
    s_prizenote: "La bille touche le premier monstre sur sa route, vise les rangées rapides si tu l'oses !",
    s_start: "Prêt, vise, feu",
    s_hits: "Touchés :", s_shots: "Tir {n} / {max}",
    s_win: "QUELLE VISÉE !",
    s_fail: "LES MONSTRES SE SONT ENFUIS !",
    s_winline: "{hits} monstres sur {shots} touchés !",
    s_failline: "Seulement {hits} touchés, il en fallait 7. Réessaie !",
    s_hint: "Prends une bille et tire sur les monstres !",
    s_banner: "TOUCHE LES MONSTRES !",
    tile_claw: "La pince",
    c_sign2: "3 ESSAIS PAR 15 MIN",
    c_lede: "La pince va et vient au-dessus du tas, appuie quand elle est au-dessus de ta peluche préférée et croise les doigts pour une bonne prise !",
    c_rule1: "Appuie pour lâcher la pince",
    c_rule2: "Si la prise est bonne, la peluche remonte avec",
    c_rule3: "3 essais par quart d'heure, pour ne pas vider la machine",
    c_prizenote: "Lot : la petite peluche que tu pêches, exactement celle que tu vois !",
    c_start: "Démarre la machine",
    c_tries: "Essais : {n} / 3",
    c_wait: "Prochain essai dans {t}",
    c_hint: "Appuie pour lâcher la pince !",
    c_locked: "La machine se repose, reviens dans {t}",
    c_win: "QUELLE PRISE !",
    c_missline: "La pince a lâché… réessaie !",
    c_done_won: "Tu as pêché {n} peluches, elles sont dans ta salle des lots !",
    c_done_won1: "Tu as pêché 1 peluche, elle est dans ta salle des lots !",
    c_done_zero_title: "PINCE VIDE !",
    c_done_zero: "La pince est remontée vide cette fois, meilleure chance la prochaine !",
    ad_offer_claw: "La pince se recharge… ou regarde une courte vidéo et repars aussitôt avec 6 nouveaux essais !",
    ad_watch: "Voir la vidéo",
    ad_no: "Non merci",
    ad_fail: "La vidéo n'a pas pu être affichée, réessaie plus tard.",
    ad_bonus: "+{n} essais bonus",
    ad_label: "Publicité",
    doc_title: "Teddy Chase – jeux gratuits : course de chevaux, la pince et plus",
    ad_offer_double: "Quitte ou double ! Regarde une courte vidéo et rends ton lot {size}.",
    ad_upgraded: "Lot amélioré, choisis ta peluche !",
    ad_offer_cans_title: "SI PRÈS DU BUT !",
    ad_offer_cans: "{n} boîtes restantes, regarde une courte vidéo et gagne 1 balle en plus !",
    ad_offer_football: "À un but d'un meilleur lot ! Regarde une courte vidéo et gagne 1 tir en plus.",
    ad_offer_shoot: "À un tir d'un meilleur lot ! Regarde une courte vidéo et gagne 1 tir en plus.",
    ad_offer_basket: "Regarde une courte vidéo et retente {level} avec le chrono remis à zéro !",
    pop_grab: "PRIS !", pop_slip: "RATÉ !",
    tile_wheel: "Roue de la fortune",
    w_sign2: "DEVINE 3 NUMÉROS SUR 20",
    w_lede: "Choisis 3 numéros et fais tourner la grande roue, si la flèche s'arrête sur l'un des tiens, tu gagnes une peluche moyenne ! Les numéros ont la couleur de leur case.",
    w_pick: "Choisis encore {n} numéros",
    w_ready: "Prêt à tourner !",
    w_spin: "TOURNE LA ROUE",
    w_spinning: "La roue tourne…",
    w_win: "NUMÉRO CHANCEUX !",
    w_winline: "La roue s'est arrêtée sur le {n}, un des tiens !",
    w_lose: "PAS CETTE FOIS",
    w_loseline: "La roue s'est arrêtée sur le {n}. Choisis des numéros et réessaie !",
    w_prizenote1: "Lot : une peluche moyenne",
    w_prizenote2: "3 sur 20, la chance sourit aux audacieux !",
    tile_race: "Petites voitures",
    rc_sign2: "PREMIER À {laps} TOURS",
    rc_lede: "Course d'autos tamponneuses vue du ciel ! Pilote sur le circuit, ramasse les boosts et pousse les autres sans te gêner, le premier à {laps} tours gagne.",
    rc_rule1: "Pilote avec le joystick dans le coin (ou les flèches)",
    rc_rule2: "Passe sur un boost pour un bon coup d'accélérateur",
    rc_rule3: "Les chocs sont permis, pousse tes rivaux dans le mur !",
    rc_prizenote: "Facile = petit · Moyen = moyen · Difficile = COUPE EN OR",
    rc_start: "DÉPART !",
    rc_ready: "PRÊT…",
    rc_go: "GO !",
    rc_track: "Circuit",
    rc_track_oval: "Ovale", rc_track_heart: "Cœur", rc_track_tri: "Triangle",
    rc_lap: "Tour {n}/{max}",
    rc_lapup: "TOUR {n}/{max}",
    rc_pos: "N° {n}",
    rc_boost: "BOOST !",
    rc_win: "VICTOIRE !",
    rc_winline: "1re place, tu as gagné la course !",
    rc_finishpop: "ARRIVÉE !",
    rc_trophy_ribbon: "COUPE DU CHAMPION !",
    rc_trophyline: "Tu as gagné en Difficile, la coupe est dans ta salle des lots !",
    rc_fail: "DRAPEAU À DAMIER",
    rc_failline: "Tu as fini n° {n}, retourne au volant !",
    tile_hang: "Hangtime",
    ht_sign2: "GARDE L'ÉQUILIBRE",
    ht_lede: "Le funambule traverse le fil, haut au-dessus de la piste. Garde l'aiguille dans la zone verte, s'il penche trop, il tombe dans le filet ! Le vent rend ça de plus en plus dur.",
    ht_rule1: "Garde l'aiguille dans la zone verte du cadran",
    ht_rule2: "Gare aux rafales, elles viennent des deux côtés",
    ht_rule3_mouse: "Bouge la souris sur les côtés pour le pencher, ou utilise les flèches",
    ht_rule3_touch: "Incline ton téléphone, ou touche les côtés de l'écran",
    ht_prizenote: "{lille}s=petit · {mellem}s=moyen · {stor}s=grand · {pokal}s=COUPE EN OR",
    ht_start_mouse: "SUR LE FIL",
    ht_start_gyro: "JOUER EN INCLINANT",
    ht_start_touch: "Jouer en touchant les côtés",
    ht_mode_gyro: "INCLINER",
    ht_mode_mouse: "SOURIS",
    ht_mode_touch: "TOUCHER",
    ht_gyro_denied: "Impossible d'utiliser l'inclinaison du téléphone, joue en touchant les côtés.",
    ht_crossings: "Traversées : {n}",
    ht_cross: "TRAVERSÉE {n} !",
    ht_win: "QUEL ÉQUILIBRE !",
    ht_winline: "Tu as tenu {s} secondes !",
    ht_trophy_ribbon: "LÉGENDE DU FIL !",
    ht_trophyline: "{s} secondes sur le fil, la coupe est dans ta salle des lots !",
    ht_fail: "DANS LE FILET",
    ht_failline: "{s} secondes, il en faut {need} pour un lot. Remonte sur le fil !",
    tile_cans: "Chamboule-tout",
    cn_sign2: "{shots} LANCERS",
    cn_lede: "Dix boîtes de conserve en pyramide, fais tomber TOUTE la tour de la table en {shots} lancers maxi ! Moins de lancers = meilleur lot.",
    cn_rule1: "Tire vers le BAS et lâche pour catapulter la balle",
    cn_rule2: "Les boîtes ne comptent que COMPLÈTEMENT tombées de la table",
    cn_rule3: "La pleine puissance n'est pas toujours la meilleure, vise la base !",
    cn_prizenote: "2 lancers = COUPE EN OR · 3 = grand · 4 = moyen · 5 = petit",
    cn_start: "LANCE !",
    cn_cans: "Boîtes restantes : {n}",
    cn_shots: "Lancer {n}/{max}",
    cn_out: "DEHORS !",
    cn_win: "LA TOUR EST TOMBÉE !",
    cn_winline: "Les 10 boîtes par terre en {n} lancers !",
    cn_trophy_ribbon: "ROI DU CHAMBOULE-TOUT !",
    cn_trophyline: "Toute la tour en seulement {n} lancers, la coupe est à toi !",
    cn_fail: "LA TOUR TIENT",
    cn_failline: "{n} boîtes ont survécu, nouvelle tour, nouvelles chances !",
    tile_mole: "Tape-taupe",
    mo_sign2: "{s} SECONDES",
    mo_lede: "Les taupes surgissent des trous, tape-les avant qu'elles replongent ! Tu as {s} secondes, et ça va de plus en plus vite.",
    mo_rule1: "Tape sur les taupes quand elles sortent",
    mo_rule2: "Les taupes dorées valent 3 points",
    mo_rule3: "Le rythme accélère, garde ton sang-froid à la fin",
    mo_prizenote: "{lille}=petit · {mellem}=moyen · {stor}=grand · {pokal}=COUPE EN OR",
    mo_start: "LANCE LA CHASSE",
    mo_hits: "Tapées : {n}",
    mo_win: "QUELLE CHASSE !",
    mo_winline: "Tu as tapé {n} taupes !",
    mo_trophy_ribbon: "MAÎTRE DES TAUPES !",
    mo_trophyline: "{n} taupes dans le temps imparti, la coupe est dans ta salle des lots !",
    mo_fail: "ELLES SE SONT ENFUIES",
    mo_failline: "Tu en as tapé {n}, il en faut au moins {need} pour un lot. Réessaie !",
    names_horse: ["Tempête", "Sucre d'Orge", "Baron Trot", "Miss Rapide", "Sabot d'Or", "Prince Pouf", "Madame Mule", "Éclair Élise", "Avoine Aimé", "Comte Galop"],
    names_race: ["Gaz-Gégé", "Turbo-Téo", "Nitro-Néo", "Frein-Fée", "Roue-Rémi", "Vroum-Léo", "Huile-Léa", "Pneu-Paco", "Zoom-Zaza", "Drift-Dan"],
    pop_goal: "BUT !", pop_saved: "ARRÊTÉ !", pop_post: "POTEAU !", pop_over: "LA BARRE !",
    pop_basket: "PANIER !", pop_hit: "TOUCHÉ !",
  },
  es: {
    menu_welcome: "BIENVENIDO A LA FERIA",
    menu_allwin: "TODOS PUEDEN GANAR",
    play: "JUGAR",
    tile_horse: "Carrera de caballos",
    tile_football: "Fútbol",
    tile_basket: "Baloncesto",
    tile_shoot: "Tiro al blanco",
    tile_prizes: "Sala de premios",
    tile_board: "Clasificación",
    prizes_one: "PREMIO",
    prizes_many: "PREMIOS",
    board_go: "VER LA TABLA",
    footer_privacy: "Privacidad",
    name_q: "¿Cómo te llamas?",
    name_note: "Tu nombre aparece en la clasificación y en la pista. Mejor usa un apodo, lo pueden ver todos los jugadores.",
    name_ph: "Tu nombre",
    name_save: "GUARDAR",
    name_err_len: "El nombre debe tener 2-12 caracteres.",
    name_err_rude: "Eso no lo podemos grabar en la copa… prueba otro.",
    back: "‹ Menú",
    sign_free: "GRATIS",
    play_again: "Jugar otra vez",
    try_again: "Reintentar",
    to_menu: "Al menú",
    your_prize: "Tu premio:",
    in_room: "– ¡ya está en tu sala de premios!",
    you: "Tú",
    ld_h1: "Teddy Chase – casetas clásicas de feria y juegos divertidos online",
    ld_intro: "Teddy Chase es una colección gratuita de quince casetas clásicas de feria para jugar directamente en el navegador, en móvil, tablet y ordenador, sin descargas y sin compras. Gana peluches de colores alegres y relucientes trofeos de oro, llena tu sala de premios y pelea por un puesto en la clasificación global. El juego está disponible en seis idiomas: danés, inglés, alemán, italiano, francés y español.",
    ld_g_horse: "El rey de las casetas: haz rodar las bolas por la rampa y acierta en los agujeros, cada punto acerca tu caballo a la meta. Tres pistas, palos bloqueadores y hasta cinco rivales.",
    ld_g_claw: "La clásica máquina de garra online: toca en el momento justo y pesca exactamente el peluche que ves en el montón. Tres intentos por cuarto de hora, así que aprovéchalos.",
    ld_g_shoot: "Una caseta de tiro como en la feria de verdad: tres filas de monstruos en movimiento, acierta 7 para premio, acierta los 10 y llévate el trofeo de oro.",
    ld_g_wheel: "Elige 3 de los 20 números de la rueda y gírala. Si la flecha cae en tu número, el peluche mediano es tuyo.",
    ld_g_race: "Carreras de coches teledirigidos vistas desde arriba con joystick, turbos y codazos, tres circuitos, cinco vueltas, y trofeo de oro para quien gane en Difícil.",
    ld_g_football: "Ocho tiros contra un portero que finta y acelera. Curva el balón a su alrededor, ocho goles seguidos valen el trofeo, con celebración de hat-trick por el camino.",
    ld_g_basket: "Tres niveles contrarreloj con una canasta que se desliza cada vez más rápido. Supera la final y elige tu peluche.",
    ld_g_mole: "60 segundos, nueve agujeros y topos cada vez más rápidos, los dorados valen tres puntos, y los curiosos son casi imposibles de pillar.",
    ld_g_cans: "Derribo de latas con física real: tira toda la pirámide de la mesa en cinco lanzamientos. Si lo logras en dos, te espera el trofeo de oro.",
    ld_g_hang: "Mantén al equilibrista en equilibrio en el viento, con ratón, flechas o inclinando el teléfono. Cuanto más aguantes, mayor el premio.",
    ld_g_punch: "Cuatro pasos, un toque cada uno: retrocede perfecto, coge impulso, clava la potencia y vuela contra el saco. Hasta 1.000 puntos, y puedes enviar el reto a un amigo.",
    ld_g_exchange: "¿Estanterías llenas? Cambia 100 peluches por una moneda de oro con el osito del logo. La moneda vale 100 premios, así que tu puesto en la clasificación no cambia.",
    ld_faq_h: "Preguntas frecuentes",
    ld_q1: "¿Los juegos son gratis?",
    ld_a1: "Sí, las quince casetas son totalmente gratuitas, y no hay compras en el juego.",
    ld_q2: "¿Puedo jugar en el móvil?",
    ld_a2: "Sí, los juegos están hechos para el móvil: controles táctiles, joystick y giroscopio, y funcionan igual de bien en tablet y ordenador.",
    ld_q3: "¿En qué idiomas está el juego?",
    ld_a3: "Danés, inglés, alemán, italiano, francés y español. El idioma se elige automáticamente según tu navegador y siempre puede cambiarse con el botón de la bandera.",
    ld_q4: "¿Qué se puede ganar?",
    ld_a4: "Peluches en tres tamaños y trofeos de oro, reunidos en tu sala de premios, y tus premios cuentan en la clasificación global.",
    tile_punch: "Golpea el saco", tile_exchange: "La bolsa de peluches", ex_go: "A LA BOLSA",
    ex_coin_one: "moneda de oro", ex_coin_many: "monedas de oro",
    ex_lede: "Cambia {n} peluches por 1 moneda de oro con el osito del logo. La moneda vale {n} premios en el tablón, tu total no cambia. ¡Y tus estanterías respiran!",
    ex_missing: "Consigue {n} peluches más para poder cambiar.",
    ex_ready: "Tienes suficientes. ¡Listo para cambiar!",
    ex_cta: "Cambiar {n} peluches por 1 moneda de oro",
    ex_note: "Los trofeos nunca se tocan. 1 moneda de oro = {n} premios en la clasificación.",
    ex_confirm_t: "¿Estás seguro?",
    ex_confirm: "Entregas {n} peluches (primero los más pequeños y antiguos) y recibes 1 moneda de oro en la sala de premios.",
    ex_yes: "Cambiar ya", ex_no: "Cancelar",
    ex_done_t: "¡Enhorabuena!", ex_done: "¡Tienes una moneda de oro! Ya está en lo alto de la sala de premios.",
    ex_more: "Cambiar otra vez",
    pb_sign2: "0-1.000 PUNTOS",
    pb_lede: "Cuatro pasos, un toque cada uno: retrocede perfecto, coge impulso, clava la potencia y golpea en el centro. Hasta 1.000 puntos, solo cuenta tu récord.",
    pb_rule1: "1. Retrocede y párate en la marca (200 puntos)",
    pb_rule2: "2. Coge impulso con el brazo (200 puntos)",
    pb_rule3: "3. Para la potencia en lo más alto (300 puntos)",
    pb_rule4: "4. Golpea el saco justo en el centro (300 puntos)",
    pb_prizenote: "Aquí no hay premios, solo gloria: bate tu récord y reta a un amigo.",
    pb_best: "Récord: {n}", pb_start: "¡DING DING!",
    pb_hint_walk: "¡Toca cuando el osito esté en la marca!",
    pb_hint_windup: "¡Toca en lo alto del impulso!",
    pb_hint_power: "¡Toca cuando la potencia esté en la zona dorada!",
    pb_hint_aim: "¡Toca cuando la mira esté en el centro del saco!",
    pb_ph_walk: "Distancia", pb_ph_windup: "Impulso", pb_ph_power: "Potencia", pb_ph_aim: "Puntería",
    pb_res_great: "¡GOLPAZO!", pb_res_ok: "¡Buen golpe!", pb_res_low: "Calienta otra vez",
    pb_res_ko: "¡EL SACO EXPLOTÓ!",
    pb_hs_btn: "Récords",
    pb_hs_month: "Este mes",
    pb_hs_all: "Histórico",
    pb_hs_empty: "Aún no hay récords",
    pb_hs_err: "No se pudo cargar la lista",
    pb_hs_close: "Cerrar",
    tile_duck: "El estanque de patos",
    dp_sign2: "PESCA 10 PATOS",
    dp_lede: "Sumerge el imán en el estanque y pesca 10 patos. La marca de la base decide el premio, ¡y 3 marcas iguales ganan un peluche!",
    dp_rule1: "Marca verde: 3 iguales = peluche pequeño",
    dp_rule2: "Marca azul: 3 iguales = peluche mediano. Moneda de oro: 3 iguales = peluche GRANDE",
    dp_rule3: "Comodín: no gana nada, más suerte con el siguiente pato",
    dp_start: "¡A PESCAR!",
    dp_hint: "Apunta con el imán y toca para pescar",
    dp_fished: "Pescados: {n}/{m}",
    dp_joker: "COMODÍN",
    dp_found_gron: "MARCA VERDE",
    dp_found_blaa: "MARCA AZUL",
    dp_found_guld: "MONEDA DE ORO",
    dp_res_win1: "¡GANASTE UN PELUCHE!",
    dp_res_win: "¡GANASTE {n} PELUCHES!",
    dp_res_none: "SIN PELUCHES ESTA VEZ",
    dp_claim: "ELIGE TUS PELUCHES",
    tile_pusher: "Empuja monedas",
    pu_sign2: "100 MONEDAS DE PLATA",
    pu_lede: "Recibes 100 monedas de plata. Calcula el momento, empuja las monedas por dos bordes y descubre cuántas monedas de oro puedes sacar de la máquina.",
    pu_rule1: "Toca para soltar una moneda desde la ranura móvil",
    pu_rule2: "Las monedas de plata de la bandeja vuelven a tu reserva",
    pu_rule3: "El oro cuenta para el récord. Las monedas de los canales laterales se pierden",
    pu_start: "¡JUGAR!",
    pu_hint: "Suelta la moneda cuando el empujador esté retraído",
    pu_last: "Las últimas monedas ruedan...",
    pu_silver: "Plata",
    pu_gold: "Oro",
    pu_res_title: "¡{n} MONEDAS DE ORO!",
    pu_res_title1: "¡1 MONEDA DE ORO!",
    pu_goldrain: "¡LLUVIA DE ORO!",
    tile_hammer: "El martillazo",
    hm_sign2: "HAZ SONAR LA CAMPANA",
    hm_lede: "Tres pasos con un toque cada uno: levanta el martillo, carga la fuerza y golpea la base en el centro. ¡Acierta en el verde y el disco vuela hacia la campana!",
    hm_rule1: "Levantar (300) y fuerza (300): para la aguja en la zona VERDE",
    hm_rule2: "Puntería (400): cuanto más cerca de la línea central, más alto vuela el disco",
    hm_rule3: "Con más de 900 puntos suena la campana y eliges un peluche GRANDE",
    hm_start: "¡DALE AL MARTILLO!",
    hm_prizenote: "Un solo premio: el peluche GRANDE por encima de 900 puntos. Cada puntuación cuenta para el récord.",
    hm_ph_pull: "Levantar",
    hm_ph_power: "Fuerza",
    hm_ph_aim: "Puntería",
    hm_hint_pull: "Toca cuando la aguja esté en el verde",
    hm_hint_power: "Toca en la zona verde, es la mejor",
    hm_hint_aim: "Golpea lo más cerca del centro que puedas",
    hm_bell: "¡SUENA LA CAMPANA!",
    hm_res_great: "¡GOLPAZO!",
    hm_res_ok: "¡BUEN GOLPE!",
    hm_res_low: "EL DISCO SE ACHICÓ",
    hm_best: "Récord: {n}",
    tile_bump: "Coches de choque",
    bp_sign2: "EMPÚJALOS FUERA",
    bp_lede: "Sumo en coches de choque: empuja a los demás por el borde de la arena. Sobrevive entre los 3 últimos en la ronda inicial y vence a los bots duros en la final.",
    bp_rule1: "Conduce con el joystick, toques a los lados o las flechas, el coche acelera solo",
    bp_rule2: "Ronda inicial: 6 coches, los últimos 3 pasan a la final",
    bp_rule3: "La final: el ganador se lleva el TROFEO DE ORO, el 2º y 3º un peluche mediano",
    bp_start: "¡EMPIEZA EL DUELO!",
    bp_round1: "RONDA INICIAL",
    bp_final: "LA FINAL",
    bp_go: "¡YA!",
    bp_left: "Quedan {n} coches",
    bp_out: "¡{name} está fuera!",
    bp_you_out: "¡TE CAÍSTE!",
    bp_qualified: "¡A LA FINAL!",
    bp_res_win: "¡GANADOR DE LA FINAL!",
    bp_res_win_sub: "¡Los empujaste a todos y ganas el trofeo de oro!",
    bp_res_second: "¡TAN CERCA DEL TÍTULO!",
    bp_res_out: "FUERA EN LA RONDA INICIAL",
    ld_g_hammer: "El clásico martillazo de feria: tres toques controlan levantar, fuerza y puntería en una barra roja, naranja y verde. Acierta siempre en el verde, suena la campana y el peluche grande es tuyo.",
    ld_g_bump: "Sumo en coches de choque: empuja a los bots por el borde de la arena redonda en dos rondas. Sobrevive la inicial, gana la final contra los bots duros y llévate el trofeo de oro.",
    pu_res_note: "La plata se acabó y la máquina está quieta. Tu oro cuenta para el récord.",
    ld_g_duck: "Pesca magnética en un estanque vivo: pesca 10 patos y dales la vuelta. Tres marcas iguales en la base ganan un peluche, y tres monedas de oro un peluche GRANDE.",
    ld_g_pusher: "Clásico empuja monedas de dos niveles: 100 monedas de plata, empujadores oscilantes y monedas de oro esperando en el borde. La plata de la bandeja se relanza, el oro cuenta para el récord.",
    pb_challenge: "Reta a un amigo", pb_copied: "¡Enlace copiado!",
    pb_share_text: "He hecho {n} puntos en Golpea el saco de Teddy Chase. ¡Supéralo!",
    hm_share_text: "He hecho {n} puntos en El martillazo de Teddy Chase. ¡Supéralo!",
    pb_ch_banner: "{name} te reta: {n} puntos. ¡Supéralo!",
    pb_ch_beat: "¡Has ganado a {name}!", pb_ch_lost: "{name} sigue en cabeza con {n} puntos.",
    size_lille: "Pequeño", size_mellem: "Mediano", size_stor: "Grande",
    color_neonpink: "Rosa", color_giftgroen: "Verde claro", color_elblaa: "Azul cielo",
    color_neonorange: "Naranja", color_skriggul: "Amarillo sol", color_neonlilla: "Lavanda",
    color_turkis: "Menta", color_knaldroed: "Rojo coral",
    type_bamse: "Osito", type_enhjoerning: "Unicornio", type_dino: "Dinosaurio",
    type_blaeksprutte: "Pulpo", type_froe: "Rana", type_kanin: "Conejo",
    type_panda: "Panda", type_loeve: "León", type_elefant: "Elefante",
    type_pingvin: "Pingüino", type_haj: "Tiburón", type_koala: "Koala",
    type_hund: "Perrito", type_giraf: "Jirafa", type_bjoern: "Oso",
    trophy: "Copa de oro",
    pp_ribbon: "¡PREMIO!",
    pp_won: "Has ganado un peluche ({size}), elige tu favorito:",
    pr_title: "SALA DE PREMIOS",
    pr_count_one: "premio", pr_count_many: "premios",
    pr_tip: "Mantén pulsado un peluche y arrástralo donde quieras",
    pr_empty: "Las estanterías están vacías…",
    pr_empty2: "¡Gana tu primer peluche!",
    lb_title: "CLASIFICACIÓN",
    lb_name: "Nombre", lb_trophies: "Copas", lb_plush: "Peluches", lb_total: "Total",
    lb_empty: "Nadie en la tabla todavía, ¡a ganar!",
    lb_note: "Global",
    lb_loading: "Cargando la clasificación…",
    lb_offline: "No se pudo cargar la clasificación global, revisa tu conexión.",
    name_device_note: "Este dispositivo tiene un puesto en la clasificación global, un nombre nuevo ocupa ese puesto.",
    h_sign2: "2 BOLAS A LA VEZ",
    h_lede: "Coge las bolas de la bandeja y ponlas en la línea de salida, ¡la posición decide tu ángulo! Hazlas rodar por la rampa y vuela sobre el borde: cada hoyo hace avanzar a tu caballo. ¡El primero en llegar a {goal} gana la carrera y un premio!",
    h_opponents: "Rivales",
    h_difficulty: "Dificultad",
    diff_let: "Fácil", diff_mellem: "Medio", diff_svaer: "Difícil",
    h_track_let: "Pista: La Clásica, tablero abierto y tiro libre al 3 rojo",
    h_track_mellem: "Pista: Doble Oro. DOS 3 rojos al fondo en las esquinas, cada uno protegido por un poste",
    h_track_svaer: "Pista: El Guardián, tres postes bloquean el tiro directo al rojo (¡vuela por encima o rodéalos!)",
    h_prizenote: "Premios: Fácil = pequeños · Medio = pequeños y medianos · Difícil = todos, ¡y cuantos más rivales, más fácil llevarte los GRANDES!",
    h_start: "Empieza la carrera",
    h_legend_red: "Rojo = 3", h_legend_blue: "Azul = 2", h_legend_yellow: "Amarillo = 1",
    h_yourhorse: "Tu caballo:",
    h_last: "Última bola: +{pts}",
    h_win: "¡HAS GANADO!", h_lose: "LA CARRERA HA TERMINADO",
    h_wonrace: "¡ganó la carrera!",
    h_noprize: "Sin premio esta vez, ¡inténtalo de nuevo!",
    h_points: "puntos",
    h_hint_take: "Coge una bola de la bandeja y ponla entre las líneas",
    h_hint_move: "Mueve la bola libremente, ¡arrastra hacia atrás para tirar!",
    f_sign2: "{shots} TIROS, {need} GOLES = PREMIO",
    f_lede: "Tienes {shots} tiros contra el portero, se desliza de lado a lado pero no llega a las esquinas. ¡Arrastra en curva para darle rosca al balón y esquivarlo!",
    f_rule1: "{shots} tiros, al menos {need} goles dan premio",
    f_rule2: "El portero se mueve, finta tras 2 goles, acelera tras 3, ¡y en el último tiro lo da TODO!",
    f_rule3: "Rosca: arrastra el dedo en curva y el tiro se dobla",
    f_rule4: "Máxima potencia (barra roja) = ¡riesgo de larguero!",
    f_prizenote: "Premio por goles: 3-4 = pequeño · 5 = mediano · 6-7 = GRANDE · los 8 = ¡COPA DE ORO!",
    f_start: "Pitido inicial",
    f_goals: "Goles:", f_shots: "Tiro {n} / {max}",
    f_win: "¡MENUDO PIE!", f_fail: "¡GANÓ EL PORTERO!",
    f_winline: "¡{goals} goles en {shots} tiros!",
    f_failline: "{goals} goles en {shots} tiros, hacían falta {need}. ¡Reinténtalo!",
    f_trophy_ribbon: "¡COPA DE ORO!",
    f_trophyline: "¡Los {shots} goles! ¡La copa de oro ya está en el estante más alto de tu sala de premios!",
    f_hint: "Coge un balón, ¡arrastra en curva para la rosca!",
    f_banner: "{shots} TIROS, ¡AL MENOS {need} GOLES!",
    f_hattrick: "¡HAT-TRICK!",
    f_hattrick2: "¡DOBLE HAT-TRICK!",
    f_hattrick_sub: "{n} GOLES • {n} TIROS",
    f_curve: "ROSCA",
    tray_empty: "VACÍO",
    b_sign2: "3 NIVELES CONTRARRELOJ",
    b_lede: "¡El tiempo es tu rival! Tienes 30 segundos por nivel: encesta {n1}, luego {n2} y en la final {n3} veces. ¡La canasta se mueve en el nivel 2 y en la final!",
    b_rule1: "Nivel 1, encesta {n} en 30 seg. (la canasta está quieta)",
    b_rule2: "Nivel 2, encesta {n} en 30 seg. (la canasta se desliza)",
    b_rule3: "La final, encesta {n} en 30 seg. (canasta rápida, ¡y tienes un balón extra!)",
    b_prizenote: "Premio: Supera los tres niveles y gana un peluche mediano, siempre, en esta caseta.",
    b_start: "Arranca el reloj",
    b_level: "Nivel", b_final: "La final",
    b_of: "Nivel {n} de {max}",
    b_win: "¡VENCISTE AL RELOJ!",
    b_winline: "¡Los {n} niveles superados!",
    b_fail: "¡SE ACABÓ EL TIEMPO!",
    b_failline: "Llegaste a {level}, sin premio esta vez.",
    b_hint: "Coge un balón de la bandeja y ponlo entre las líneas",
    b_banner1: "¡ENCESTA {n} EN 30 SEG!",
    b_banner2: "{level}, ¡ENCESTA {n} EN 30 SEG!",
    b_banner3: "FINAL, ¡ENCESTA {n} · BALÓN EXTRA!",
    s_sign2: "{shots} TIROS. DALES A LOS MONSTRUOS",
    s_lede: "Los monstruos desfilan en tres filas, ¡cuanto más lejos, más rápido van! Tienes {shots} tiros. ¡Dale a todos los que puedas!",
    s_rule1: "{shots} tiros, acierta a 7 monstruos para un peluche pequeño",
    s_rule2: "8 aciertos = peluche mediano · 9 = peluche GRANDE",
    s_rule3: "Las calabazas del fondo vuelven a levantarse, ¡el resto se queda abajo!",
    s_rule4: "¡Los 10 = COPA DE ORO!",
    s_trophy_ribbon: "¡COPA DE ORO!",
    s_trophyline: "¡Los {shots} monstruos! ¡La copa de oro ya está en el estante más alto de tu sala de premios!",
    s_prizenote: "La bola le da al primer monstruo en su camino, ¡apunta a las filas rápidas si te atreves!",
    s_start: "Preparado, apunta, fuego",
    s_hits: "Aciertos:", s_shots: "Tiro {n} / {max}",
    s_win: "¡QUÉ PUNTERÍA!",
    s_fail: "¡LOS MONSTRUOS ESCAPARON!",
    s_winline: "¡{hits} de {shots} monstruos!",
    s_failline: "Solo {hits} aciertos, hacían falta 7. ¡Reinténtalo!",
    s_hint: "¡Coge una bola y dispara a los monstruos!",
    s_banner: "¡DALES A LOS MONSTRUOS!",
    tile_claw: "La garra",
    c_sign2: "3 INTENTOS CADA 15 MIN",
    c_lede: "La garra va y viene sobre el montón, ¡toca cuando esté sobre tu peluche favorito y cruza los dedos para un buen agarre!",
    c_rule1: "Toca para soltar la garra",
    c_rule2: "Si aciertas de lleno, el peluche sube con ella",
    c_rule3: "3 intentos por cuarto de hora, para que no vacíen la máquina",
    c_prizenote: "Premio: el peluche pequeño que pesques, ¡exactamente el que ves!",
    c_start: "Arranca la máquina",
    c_tries: "Intentos: {n} / 3",
    c_wait: "Próximo intento en {t}",
    c_hint: "¡Toca para soltar la garra!",
    c_locked: "La máquina descansa, vuelve en {t}",
    c_win: "¡MENUDO AGARRE!",
    c_missline: "La garra soltó su presa… ¡reinténtalo!",
    c_done_won: "Pescaste {n} peluches, ¡ya están en tu sala de premios!",
    c_done_won1: "Pescaste 1 peluche, ¡ya está en tu sala de premios!",
    c_done_zero_title: "¡GARRA VACÍA!",
    c_done_zero: "La garra no pescó nada esta vez, ¡más suerte la próxima!",
    ad_offer_claw: "La garra se está recargando… ¡o mira un vídeo corto y consigue 6 intentos nuevos al instante!",
    ad_watch: "Ver vídeo",
    ad_no: "No, gracias",
    ad_fail: "El vídeo no se pudo mostrar, inténtalo más tarde.",
    ad_bonus: "+{n} intentos extra",
    ad_label: "Anuncio",
    doc_title: "Teddy Chase – juegos gratis: carrera de caballos, la garra y más",
    ad_offer_double: "¡Doble o nada! Mira un vídeo corto y haz tu premio {size}.",
    ad_upgraded: "¡Premio mejorado, elige tu peluche!",
    ad_offer_cans_title: "¡TAN CERCA!",
    ad_offer_cans: "Quedan {n} latas, ¡mira un vídeo corto y consigue 1 bola extra!",
    ad_offer_football: "¡A un gol de un premio mejor! Mira un vídeo corto y consigue 1 tiro extra.",
    ad_offer_shoot: "¡A un acierto de un premio mejor! Mira un vídeo corto y consigue 1 tiro extra.",
    ad_offer_basket: "¡Mira un vídeo corto y reintenta {level} con el reloj a cero!",
    pop_grab: "¡AGARRADO!", pop_slip: "¡RESBALÓ!",
    tile_wheel: "Rueda de la fortuna",
    w_sign2: "ADIVINA 3 DE 20 NÚMEROS",
    w_lede: "Elige 3 números y gira la gran rueda, si la flecha cae en uno de los tuyos, ¡ganas un peluche mediano! Los números tienen el mismo color que su casilla.",
    w_pick: "Elige {n} números más",
    w_ready: "¡Listo para girar!",
    w_spin: "GIRA LA RUEDA",
    w_spinning: "La rueda gira…",
    w_win: "¡NÚMERO DE LA SUERTE!",
    w_winline: "La rueda cayó en el {n}, ¡uno de los tuyos!",
    w_lose: "ESTA VEZ NO",
    w_loseline: "La rueda cayó en el {n}. ¡Elige números y reinténtalo!",
    w_prizenote1: "Premio: un peluche mediano",
    w_prizenote2: "3 de 20, ¡la suerte sonríe a los valientes!",
    tile_race: "Coches de carreras",
    rc_sign2: "PRIMERO A {laps} VUELTAS",
    rc_lede: "¡Carrera de coches de choque vista desde arriba! Conduce por el circuito, recoge los boosts y empuja a los demás sin miedo, el primero en dar {laps} vueltas gana.",
    rc_rule1: "Conduce con el joystick de la esquina (o las flechas)",
    rc_rule2: "Pasa por un boost y recibe un buen empujón",
    rc_rule3: "Los choques están permitidos, ¡empuja a tus rivales contra el muro!",
    rc_prizenote: "Fácil = pequeño · Medio = mediano · Difícil = COPA DE ORO",
    rc_start: "¡EMPIEZA LA CARRERA!",
    rc_ready: "PREPARADOS…",
    rc_go: "¡YA!",
    rc_track: "Circuito",
    rc_track_oval: "Óvalo", rc_track_heart: "Corazón", rc_track_tri: "Triángulo",
    rc_lap: "Vuelta {n}/{max}",
    rc_lapup: "VUELTA {n}/{max}",
    rc_pos: "N.º {n}",
    rc_boost: "¡BOOST!",
    rc_win: "¡VICTORIA!",
    rc_winline: "1.er puesto, ¡ganaste la carrera!",
    rc_finishpop: "¡META!",
    rc_trophy_ribbon: "¡COPA DE CAMPEÓN!",
    rc_trophyline: "Ganaste en Difícil, ¡la copa ya está en tu sala de premios!",
    rc_fail: "BANDERA A CUADROS",
    rc_failline: "Cruzaste la meta en el puesto {n}, ¡de vuelta al volante!",
    tile_hang: "Hangtime",
    ht_sign2: "MANTÉN EL EQUILIBRIO",
    ht_lede: "El funambulista cruza la cuerda floja, muy por encima de la pista. Mantén la aguja en la zona verde, ¡si se inclina demasiado, cae a la red! El viento lo hace cada vez más difícil.",
    ht_rule1: "Mantén la aguja en la zona verde del medidor",
    ht_rule2: "Cuidado con las rachas de viento, vienen de ambos lados",
    ht_rule3_mouse: "Mueve el ratón a los lados para inclinarlo, o usa las flechas",
    ht_rule3_touch: "Inclina el teléfono, o mantén pulsados los lados de la pantalla",
    ht_prizenote: "{lille}s=pequeño · {mellem}s=mediano · {stor}s=grande · {pokal}s=COPA DE ORO",
    ht_start_mouse: "A LA CUERDA",
    ht_start_gyro: "JUGAR INCLINANDO",
    ht_start_touch: "Jugar tocando los lados",
    ht_mode_gyro: "INCLINAR",
    ht_mode_mouse: "RATÓN",
    ht_mode_touch: "TOQUE",
    ht_gyro_denied: "No se pudo usar la inclinación del teléfono, usa los toques laterales.",
    ht_crossings: "Cruces: {n}",
    ht_cross: "¡CRUCE {n}!",
    ht_win: "¡QUÉ EQUILIBRIO!",
    ht_winline: "¡Aguantaste {s} segundos!",
    ht_trophy_ribbon: "¡LEYENDA DEL ALAMBRE!",
    ht_trophyline: "{s} segundos en la cuerda, ¡la copa ya está en tu sala de premios!",
    ht_fail: "A LA RED",
    ht_failline: "{s} segundos, necesitas {need} para un premio. ¡Sube otra vez!",
    tile_cans: "Derriba las latas",
    cn_sign2: "{shots} LANZAMIENTOS",
    cn_lede: "Diez latas en pirámide, ¡tira TODA la torre de la mesa en {shots} lanzamientos como máximo! Cuantos menos uses, mejor premio.",
    cn_rule1: "Arrastra hacia ABAJO y suelta para catapultar la bola",
    cn_rule2: "Las latas solo cuentan cuando están TOTALMENTE fuera de la mesa",
    cn_rule3: "La máxima potencia no siempre es lo mejor, ¡apunta a la base!",
    cn_prizenote: "2 tiros = COPA DE ORO · 3 = grande · 4 = mediano · 5 = pequeño",
    cn_start: "¡A LANZAR!",
    cn_cans: "Latas restantes: {n}",
    cn_shots: "Tiro {n}/{max}",
    cn_out: "¡FUERA!",
    cn_win: "¡CAYÓ LA TORRE!",
    cn_winline: "¡Las 10 latas fuera en {n} lanzamientos!",
    cn_trophy_ribbon: "¡REY DE LAS LATAS!",
    cn_trophyline: "Toda la torre en solo {n} lanzamientos, ¡la copa es tuya!",
    cn_fail: "LA TORRE SIGUE EN PIE",
    cn_failline: "{n} latas sobrevivieron, ¡nueva torre, nuevas oportunidades!",
    tile_mole: "Golpea al topo",
    mo_sign2: "{s} SEGUNDOS",
    mo_lede: "Los topos salen en tropel de sus agujeros, ¡golpéalos antes de que vuelvan a esconderse! Tienes {s} segundos, y va cada vez más rápido.",
    mo_rule1: "Toca a los topos mientras están fuera",
    mo_rule2: "Los topos dorados valen 3 puntos",
    mo_rule3: "El ritmo sube, mantén la calma al final",
    mo_prizenote: "{lille}=pequeño · {mellem}=mediano · {stor}=grande · {pokal}=COPA DE ORO",
    mo_start: "¡EMPIEZA LA CAZA!",
    mo_hits: "Golpeados: {n}",
    mo_win: "¡QUÉ CACERÍA!",
    mo_winline: "¡Golpeaste a {n} topos!",
    mo_trophy_ribbon: "¡MAESTRO DE LOS TOPOS!",
    mo_trophyline: "{n} topos a tiempo, ¡la copa ya está en tu sala de premios!",
    mo_fail: "SE ESCAPARON",
    mo_failline: "Golpeaste a {n}, necesitas al menos {need} para un premio. ¡Reinténtalo!",
    names_horse: ["Tormenta", "Azucarillo", "Barón Trote", "Doña Veloz", "Casco de Oro", "Don Resoplo", "Madam Mula", "Rayo Rita", "Avena Ana", "Conde Galope"],
    names_race: ["Gas-Gaspa", "Turbo-Tom", "Gasolino", "Nitrón", "Freno-Flo", "Rueda-Rai", "Zoom-Zoe", "Aceite-Al", "Chispas", "Turbina"],
    pop_goal: "¡GOL!", pop_saved: "¡PARADA!", pop_post: "¡PALO!", pop_over: "¡LARGUERO!",
    pop_basket: "¡CANASTA!", pop_hit: "¡DIANA!",
  },
};
